import React, { useState, useEffect } from 'react';
import { Container, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../common.scss';

import config from '../../config';
import { encryptData } from '../../utils/cryptoUtils';

function VehicleRepoList() {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [page, setPage] = useState(1);
  const [loadingId, setLoadingId] = useState(null);
  const [uploadingId, setUploadingId] = useState(null);
  const [files, setFiles] = useState({});

  // --- PRELOADER: tracks POST request in-flight state (for modal submissions) ---
  const [postLoading, setPostLoading] = useState(false);
  const [showNotesModal, setShowNotesModal] = useState(false);
  const [selectedAgreement, setSelectedAgreement] = useState('');
  const [selectedAction, setSelectedAction] = useState('');
  const [notes, setNotes] = useState('');
  const [showResendModal, setShowResendModal] = useState(false);
  const [resendAgreement, setResendAgreement] = useState('');
  const [resendNotes, setResendNotes] = useState('');
  const [showReuploadModal, setShowReuploadModal] = useState(false);
  const [reuploadAgreement, setReuploadAgreement] = useState('');
  const [showViewNotesModal, setShowViewNotesModal] = useState(false);
  const [viewNotesContent, setViewNotesContent] = useState('');
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [activityLogs, setActivityLogs] = useState([]);
  const [activityLoading, setActivityLoading] = useState(false);
  const [expandedNotes, setExpandedNotes] = useState({});
  const [expandedRow, setExpandedRow] = useState(null);
  const [showFlowModal, setShowFlowModal] = useState(false);
  const [selectedFlowItem, setSelectedFlowItem] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [showSurrenderConfirmModal, setShowSurrenderConfirmModal] = useState(false);
  const [selectedSurrenderAgreement, setSelectedSurrenderAgreement] = useState('');
  const [surrenderNote, setSurrenderNote] = useState('');
  const [showLegalOptionsModal, setShowLegalOptionsModal] = useState(false);
  const [legalOptionsAgreement, setLegalOptionsAgreement] = useState('');
  const [showSection9Modal, setShowSection9Modal] = useState(false);
  const [section9Agreement, setSection9Agreement] = useState('');
  const [section9Loading, setSection9Loading] = useState(false);
  const [section9Dpd, setSection9Dpd] = useState('');
  const [legalOptionsDpd, setLegalOptionsDpd] = useState('');
  const [showForwardToLegalModal, setShowForwardToLegalModal] = useState(false);
  const [forwardToLegalAgreement, setForwardToLegalAgreement] = useState('');
  const [forwardToLegalLoading, setForwardToLegalLoading] = useState(false);
  const [showMakerDetailsModal, setShowMakerDetailsModal] = useState(false);
  const [makerDetailsLoading, setMakerDetailsLoading] = useState(false);
  const [makerDetailsData, setMakerDetailsData] = useState(null);
  const [showLegalForwardDetailsModal, setShowLegalForwardDetailsModal] = useState(false);
  const [legalForwardLoading, setLegalForwardLoading] = useState(false);
  const [legalForwardData, setLegalForwardData] = useState(null);
  const [showLnrSection9Modal, setShowLnrSection9Modal] = useState(false);
  const [lnrSection9Item, setLnrSection9Item] = useState(null);
  const [lnrFile, setLnrFile] = useState(null);
  const [section9FinalFile, setSection9FinalFile] = useState(null);
  const [lnrSection9Loading, setLnrSection9Loading] = useState(false);
  const [showSection138Modal, setShowSection138Modal] = useState(false);
  const [section138Agreement, setSection138Agreement] = useState('');
  const [section138Note, setSection138Note] = useState('');
  // View Documents modal (Checker + Maker + Legal Team sabke liye)
  const [showSection138DocsModal, setShowSection138DocsModal] = useState(false);
  const [section138DocsData, setSection138DocsData] = useState(null);
  const [section138DocsLoading, setSection138DocsLoading] = useState(false);

  const [showLegalLetterModal, setShowLegalLetterModal] = useState(false);
  const [legalLetterAgreement, setLegalLetterAgreement] = useState('');
  const [legalLetterNote, setLegalLetterNote] = useState('');
  const [legalLetterLoading, setLegalLetterLoading] = useState(false);

  const [showLegalLetterUploadModal, setShowLegalLetterUploadModal] = useState(false);
  const [legalLetterUploadAgreement, setLegalLetterUploadAgreement] = useState('');
  const [legalLetterUploadLoading, setLegalLetterUploadLoading] = useState(false);
  const [showSurrenderActionModal, setShowSurrenderActionModal] = useState(false);
  const [surrenderActionAgreement, setSurrenderActionAgreement] = useState('');
  const [surrenderAction, setSurrenderAction] = useState(''); // 'approve' | 'reject'
  const [surrenderActionNote, setSurrenderActionNote] = useState('');
  const [surrenderActionLoading, setSurrenderActionLoading] = useState(false);
  const [legalLetterFiles, setLegalLetterFiles] = useState({
    cheques: [],
    loan_agreement: null,
    customer_details: null,
    foreclosure: null,
    soa: null,
    other_documents: [],
  });

  const [showLegalLetterDocsModal, setShowLegalLetterDocsModal] = useState(false);
  const [legalLetterDocsData, setLegalLetterDocsData] = useState(null);
  const [legalLetterDocsLoading, setLegalLetterDocsLoading] = useState(false);

  const [showLegalLetterNextStepModal, setShowLegalLetterNextStepModal] = useState(false);
  const [legalLetterNextStepAgreement, setLegalLetterNextStepAgreement] = useState('');
  const [legalLetterNextStepNote, setLegalLetterNextStepNote] = useState('');
  const [legalLetterNextStepLoading, setLegalLetterNextStepLoading] = useState(false);

  // Legal Team - Next Step (Note) modal
  const [showSection138NextStepModal, setShowSection138NextStepModal] = useState(false);
  const [section138NextStepAgreement, setSection138NextStepAgreement] = useState('');
  const [section138NextStepNote, setSection138NextStepNote] = useState('');
  const [section138NextStepLoading, setSection138NextStepLoading] = useState(false);
  const [section138Loading, setSection138Loading] = useState(false);
  const [forwardToLegalFiles, setForwardToLegalFiles] = useState({
    soa: null,
    legal_closure_document: null,
    loan_agreement: null,
  });
  const [forwardToLegalNote, setForwardToLegalNote] = useState('');
  const [section9Data, setSection9Data] = useState({
    customer_name: '',
    vehicle_name: '',
    receiver_name: '',
    loan_number: '',
    police_station_address: '',
  });
  const [showRequestLegalSection138Modal, setShowRequestLegalSection138Modal] = useState(false);
  const [requestLegalSection138Agreement, setRequestLegalSection138Agreement] = useState('');
  const [requestLegalSection138Loading, setRequestLegalSection138Loading] = useState(false);
  const [requestLegalSection138Files, setRequestLegalSection138Files] = useState({
    cheques: [],
    loan_agreement: null,
    customer_details: null,
    foreclosure: null,
    soa: null,
  });
  const [section9Files, setSection9Files] = useState([]);
  const handleViewActivities = async (agreementNo) => {
    try {
      setActivityLoading(true);
      setShowActivityModal(true);

      const res = await fetch(`${config.API_BASE_URL}getCaseActivityLogs/${agreementNo}`);

      const result = await res.json();

      if (result.status) {
        setActivityLogs(result.data || []);
      } else {
        toast.error(result.message || 'No activities found');
        setActivityLogs([]);
      }
    } catch {
      toast.error('Failed to load activities');
    } finally {
      setActivityLoading(false);
    }
  };

  const handleStaticFlowModal = async (item) => {
    try {
      setActivityLoading(true);

      const res = await fetch(`${config.API_BASE_URL}getCaseActivityLogs/${item.AgreementNo}`);

      const result = await res.json();

      if (result.status) {
        setActivityLogs(result.data || []);
      } else {
        setActivityLogs([]);
      }
    } catch {
      setActivityLogs([]);
    } finally {
      setActivityLoading(false);
    }

    setSelectedFlowItem(item);

    setShowFlowModal(true);
  };

  const navigate = useNavigate();
  const perPage = 10;

  const userInfo = useSelector((state) => state.userInfo);

  const userId = userInfo?.id;
  const userRole = userInfo?.roleIdWithName?.[0]?.role_name?.toLowerCase().trim();
  const allowedRepoUsers = [
    'super admin',
    'manager',
    'team leader',
    'user',
    'dealer',
    'regional sales manager',
    'regional head',
    'cluster head',
  ];

  console.log('ROLE:', userRole);
  const isAdmin = userRole === 'super admin';

  const isLegalTeam = ['legal team', 'super admin'].includes(userRole);

  const isMaker = [
    'user',
    'manager',
    'team leader',
    'regional sales manager',
    'regional head',
    'cluster head',
    'super admin',
  ].includes(userRole);

  const isChecker = ['credit operations', 'super admin'].includes(userRole);

  const allowedStatuses = isChecker
    ? ['Pending', 'Pending for Court Order Review']
    : ['Section 9 Initiated', 'Forwarded to Legal Team'];

  const visibleData = data.filter((item) => {
    const status = item.legal_status || item.status;

    return (
      !status ||
      [
        'Pending',
        'Approved',
        'Rejected',
        'Pending for Court Order Review',
        'Court Order Approved',
        'Court Order Rejected',
        'Repo Initiated',
        'Repo Checklist Submitted',
        'Section 9 Initiated',
        'Forwarded to Legal Team',
        'Section 138 Initiated',
        'Requested To Legal Team For Section 138',
        'Section 138 Legal Team Reviewed',
        'Section 138 Legal Team Reviewed',
        'LEGAL_LETTER_INITIATED',
        'LEGAL_LETTER_FORWARDED_TO_LEGAL_TEAM',
        'LEGAL_LETTER_REVIEWED',
        'LEGAL_LETTER_COMPLETED',
        'Pending Surrender Approval',
        'Surrender Rejected',
      ].includes(status)
    );
  });

  const fetchData = () => {
    fetch(
      `${config.API_BASE_URL}getEligibleLoansForRepos?page=${page}&limit=10&status=${statusFilter}&search=${search}`
    )
      .then((res) => res.json())
      .then((res) => {
        console.log('PAGE =', page);
        console.log('API RESPONSE =', res);

        if (res.status) {
          setData(res.data || []);
          setTotalPages(res.pagination?.total_pages || 1);
        }
      })
      .catch(() => {
        toast.error('API Error');
      });
  };

  useEffect(() => {
    fetchData();
  }, [page, statusFilter, search]);

  const handleSendForApproval = async (agreementNo) => {
    try {
      setLoadingId(agreementNo);

      const res = await fetch(`${config.API_BASE_URL}createLegalAction`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          agreement_no: agreementNo,
          legal_type: 'Section 9',
          user_id: userId,
        }),
      });

      const result = await res.json();

      if (result.status) {
        toast.success('Sent for approval');
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Error sending request');
    } finally {
      setLoadingId(null);
    }
  };

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(',')[1]); // strip data:...base64, prefix
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const handleSubmitSection9 = async () => {
    if (
      !section9Data.customer_name.trim() ||
      !section9Data.vehicle_name.trim() ||
      !section9Data.receiver_name.trim() ||
      !section9Data.loan_number.trim() ||
      !section9Data.police_station_address.trim()
    ) {
      toast.error('Please fill all fields');
      return;
    }

    setSection9Loading(true);

    try {
      // convert all selected files to base64
      const documents = await Promise.all(
        section9Files.map(async (f) => ({
          name: f.name,
          type: f.type,
          data: await fileToBase64(f), // base64 string (no prefix)
        }))
      );

      const payload = {
        agreement_no: section9Agreement,
        legal_type: 'Section 9',
        user_id: userId,
        customer_name: section9Data.customer_name,
        vehicle_name: section9Data.vehicle_name,
        receiver_name: section9Data.receiver_name,
        loan_number: section9Data.loan_number,
        police_station_address: section9Data.police_station_address,
        dpd_days: section9Dpd,
        documents, // 👈 naya field add
      };
      console.log('SECTION9 PAYLOAD:', payload);
      const res = await fetch(`${config.API_BASE_URL}saveSectionnineLegalAction`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowSection9Modal(false);
        setSection9Agreement('');
        setSection9Data({
          customer_name: '',
          vehicle_name: '',
          receiver_name: '',
          loan_number: '',
          police_station_address: '',
        });
        setSection9Files([]); // 👈 files bhi reset karna mat bhoolna
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setSection9Loading(false);
    }
  };

  const handleSubmitForwardToLegal = async () => {
    if (
      !forwardToLegalFiles.soa ||
      !forwardToLegalFiles.legal_closure_document ||
      !forwardToLegalFiles.loan_agreement
    ) {
      toast.error('Please upload all 3 documents');
      return;
    }

    if (!forwardToLegalNote.trim()) {
      toast.error('Please enter a note');
      return;
    }

    setForwardToLegalLoading(true);

    try {
      const soaDoc = {
        name: forwardToLegalFiles.soa.name,
        type: forwardToLegalFiles.soa.type,
        data: await fileToBase64(forwardToLegalFiles.soa),
      };

      const legalClosureDoc = {
        name: forwardToLegalFiles.legal_closure_document.name,
        type: forwardToLegalFiles.legal_closure_document.type,
        data: await fileToBase64(forwardToLegalFiles.legal_closure_document),
      };

      const loanAgreementDoc = {
        name: forwardToLegalFiles.loan_agreement.name,
        type: forwardToLegalFiles.loan_agreement.type,
        data: await fileToBase64(forwardToLegalFiles.loan_agreement),
      };

      const payload = {
        agreement_no: forwardToLegalAgreement,
        user_id: userId,
        notes: forwardToLegalNote,
        soa: soaDoc,
        legal_closure_document: legalClosureDoc,
        loan_agreement: loanAgreementDoc,
      };

      console.log('FORWARD TO LEGAL PAYLOAD:', payload);

      const res = await fetch(`${config.API_BASE_URL}forwardSection9ToLegalTeam`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message || 'Forwarded to Legal Team successfully');
        setShowForwardToLegalModal(false);
        setForwardToLegalAgreement('');
        setForwardToLegalFiles({ soa: null, legal_closure_document: null, loan_agreement: null });
        setForwardToLegalNote('');
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setForwardToLegalLoading(false);
    }
  };

  const handleViewLegalForwardDetails = async (agreementNo) => {
    setShowLegalForwardDetailsModal(true);

    setLegalForwardLoading(true);

    setLegalForwardData(null);

    try {
      const payload = {
        agreement_no: agreementNo,
      };

      const res = await fetch(`${config.API_BASE_URL}getSection9LegalForwardDetails`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encryptData(payload),
      });
      const result = await res.json();
      if (result.status) {
        setLegalForwardData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      toast.error('Failed to load details');
    } finally {
      setLegalForwardLoading(false);
    }
  };

  const handleSubmitSection138 = async () => {
    if (!section138Note.trim()) {
      toast.error('Please enter note');
      return;
    }

    setSection138Loading(true);

    try {
      const payload = {
        agreement_no: section138Agreement,
        user_id: userId,
        notes: section138Note,
      };

      const res = await fetch(`${config.API_BASE_URL}saveSection138LegalAction`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowSection138Modal(false);
        setSection138Agreement('');
        setSection138Note('');
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setSection138Loading(false);
    }
  };

  const handleSubmitRequestLegalSection138 = async () => {
    if (requestLegalSection138Files.cheques.length === 0) {
      toast.error('Please upload at least one Cheque');
      return;
    }

    if (
      !requestLegalSection138Files.loan_agreement ||
      !requestLegalSection138Files.customer_details ||
      !requestLegalSection138Files.foreclosure ||
      !requestLegalSection138Files.soa
    ) {
      toast.error('Please upload all required documents');
      return;
    }

    setRequestLegalSection138Loading(true);

    try {
      const cheques = await Promise.all(
        requestLegalSection138Files.cheques.map(async (f) => ({
          name: f.name,
          type: f.type,
          data: await fileToBase64(f),
        }))
      );

      const loanAgreementDoc = {
        name: requestLegalSection138Files.loan_agreement.name,
        type: requestLegalSection138Files.loan_agreement.type,
        data: await fileToBase64(requestLegalSection138Files.loan_agreement),
      };

      const customerDetailsDoc = {
        name: requestLegalSection138Files.customer_details.name,
        type: requestLegalSection138Files.customer_details.type,
        data: await fileToBase64(requestLegalSection138Files.customer_details),
      };

      const foreclosureDoc = {
        name: requestLegalSection138Files.foreclosure.name,
        type: requestLegalSection138Files.foreclosure.type,
        data: await fileToBase64(requestLegalSection138Files.foreclosure),
      };

      const soaDoc = {
        name: requestLegalSection138Files.soa.name,
        type: requestLegalSection138Files.soa.type,
        data: await fileToBase64(requestLegalSection138Files.soa),
      };

      const payload = {
        agreement_no: requestLegalSection138Agreement,
        user_id: userId,
        cheques,
        loan_agreement: loanAgreementDoc,
        customer_details: customerDetailsDoc,
        foreclosure: foreclosureDoc,
        soa: soaDoc,
      };

      const res = await fetch(`${config.API_BASE_URL}requestSection138ToLegalTeam`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message || 'Requested to Legal Team successfully');
        setShowRequestLegalSection138Modal(false);
        setRequestLegalSection138Agreement('');
        setRequestLegalSection138Files({
          cheques: [],
          loan_agreement: null,
          customer_details: null,
          foreclosure: null,
          soa: null,
        });
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setRequestLegalSection138Loading(false);
    }
  };

  const handleViewSection138Documents = async (agreementNo) => {
    setShowSection138DocsModal(true);
    setSection138DocsLoading(true);
    setSection138DocsData(null);

    try {
      const payload = { agreement_no: agreementNo };

      const res = await fetch(`${config.API_BASE_URL}getSection138LegalForwardDetails`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        setSection138DocsData(result.data);
      } else {
        toast.error(result.message || 'No documents found');
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to load documents');
    } finally {
      setSection138DocsLoading(false);
    }
  };

  const handleSubmitSection138NextStep = async () => {
    if (!section138NextStepNote.trim()) {
      toast.error('Please enter note');
      return;
    }

    setSection138NextStepLoading(true);

    try {
      const payload = {
        agreement_no: section138NextStepAgreement,
        user_id: userId,
        notes: section138NextStepNote,
      };

      const res = await fetch(`${config.API_BASE_URL}saveSection138NextStepNote`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowSection138NextStepModal(false);
        setSection138NextStepAgreement('');
        setSection138NextStepNote('');
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setSection138NextStepLoading(false);
    }
  };

  const handleViewMakerDetails = async (agreementNo) => {
    console.log('CLICKED', agreementNo);
    setShowMakerDetailsModal(true);
    setMakerDetailsLoading(true);
    setMakerDetailsData(null);

    try {
      const payload = { agreement_no: agreementNo };

      const res = await fetch(`${config.API_BASE_URL}getSection9MakerDetails`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        setMakerDetailsData(result.data);
      } else {
        toast.error(result.message || 'No details found');
        setMakerDetailsData(null);
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to load maker details');
    } finally {
      setMakerDetailsLoading(false);
    }
  };

  const handleSubmitLegalLetter = async () => {
    if (!legalLetterNote.trim()) {
      toast.error('Please enter note');
      return;
    }

    setLegalLetterLoading(true);

    try {
      const payload = {
        agreement_no: legalLetterAgreement,
        user_id: userId,
        notes: legalLetterNote,
      };

      const res = await fetch(`${config.API_BASE_URL}saveLegalLetterAction`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowLegalLetterModal(false);
        setLegalLetterAgreement('');
        setLegalLetterNote('');
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setLegalLetterLoading(false);
    }
  };

  const handleSubmitLegalLetterUpload = async () => {
    const hasAny =
      legalLetterFiles.cheques.length > 0 ||
      legalLetterFiles.loan_agreement ||
      legalLetterFiles.customer_details ||
      legalLetterFiles.foreclosure ||
      legalLetterFiles.soa ||
      legalLetterFiles.other_documents.length > 0;

    if (!hasAny) {
      toast.error('Please upload at least one document');
      return;
    }

    setLegalLetterUploadLoading(true);

    try {
      const cheques = await Promise.all(
        legalLetterFiles.cheques.map(async (f) => ({
          name: f.name,
          type: f.type,
          data: await fileToBase64(f),
        }))
      );

      const otherDocuments = await Promise.all(
        legalLetterFiles.other_documents.map(async (f) => ({
          name: f.name,
          type: f.type,
          data: await fileToBase64(f),
        }))
      );

      const singleDoc = async (file) =>
        file ? { name: file.name, type: file.type, data: await fileToBase64(file) } : null;

      const payload = {
        agreement_no: legalLetterUploadAgreement,
        user_id: userId,
        cheques,
        loan_agreement: await singleDoc(legalLetterFiles.loan_agreement),
        customer_details: await singleDoc(legalLetterFiles.customer_details),
        foreclosure: await singleDoc(legalLetterFiles.foreclosure),
        soa: await singleDoc(legalLetterFiles.soa),
        other_documents: otherDocuments,
      };

      const res = await fetch(`${config.API_BASE_URL}forwardLegalLetterToLegalTeam`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message || 'Uploaded successfully');
        setShowLegalLetterUploadModal(false);
        setLegalLetterUploadAgreement('');
        setLegalLetterFiles({
          cheques: [],
          loan_agreement: null,
          customer_details: null,
          foreclosure: null,
          soa: null,
          other_documents: [],
        });
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setLegalLetterUploadLoading(false);
    }
  };

  const handleViewLegalLetterDocuments = async (agreementNo) => {
    setShowLegalLetterDocsModal(true);
    setLegalLetterDocsLoading(true);
    setLegalLetterDocsData(null);

    try {
      const payload = { agreement_no: agreementNo };

      const res = await fetch(`${config.API_BASE_URL}getLegalLetterForwardDetails`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        setLegalLetterDocsData(result.data);
      } else {
        toast.error(result.message || 'No documents found');
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to load documents');
    } finally {
      setLegalLetterDocsLoading(false);
    }
  };

  const handleSubmitLegalLetterNextStep = async () => {
    if (!legalLetterNextStepNote.trim()) {
      toast.error('Please enter note');
      return;
    }

    setLegalLetterNextStepLoading(true);

    try {
      const payload = {
        agreement_no: legalLetterNextStepAgreement,
        user_id: userId,
        notes: legalLetterNextStepNote,
      };

      const res = await fetch(`${config.API_BASE_URL}saveLegalLetterNextStep`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowLegalLetterNextStepModal(false);
        setLegalLetterNextStepAgreement('');
        setLegalLetterNextStepNote('');
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong');
    } finally {
      setLegalLetterNextStepLoading(false);
    }
  };

  const getForwardedBadgeText = (item) => {
    const hasLnr = !!item.lnr_document;
    const hasSection9 = !!item.section9_final_document;

    if (hasLnr) return 'LNR Uploaded';
    if (hasSection9) return 'Section 9 Uploaded';
    return 'Forwarded To Legal Team For Section 9';
  };

  const getLnrSection9ButtonConfig = (item) => {
    const hasLnr = !!item.lnr_document;
    const hasSection9 = !!item.section9_final_document;

    if (hasLnr && hasSection9) {
      return { text: '✓ ALL DOCS UPLOADED', bg: '#16a34a', blink: false };
    }
    if (hasLnr) {
      return { text: 'LNR UPLOADED ✓', bg: '#16a34a', blink: true };
    }
    if (hasSection9) {
      return { text: 'SECTION 9 UPLOADED ✓', bg: '#2563eb', blink: true };
    }
    return { text: 'UPLOAD LNR', bg: '#0f172a', blink: false };
  };

  const submitLnrSection9Documents = async () => {
    if (!lnrFile && !section9FinalFile) {
      toast.error('Please select LNR or Section 9 file');
      return;
    }

    setLnrSection9Loading(true);

    try {
      const payload = {
        agreement_no: lnrSection9Item.AgreementNo,
        user_id: userId,
      };

      if (lnrFile) {
        payload.lnr_document = {
          name: lnrFile.name,
          type: lnrFile.type,
          data: await fileToBase64(lnrFile),
        };
      }

      if (section9FinalFile) {
        payload.section9_document = {
          name: section9FinalFile.name,
          type: section9FinalFile.type,
          data: await fileToBase64(section9FinalFile),
        };
      }

      const res = await fetch(`${config.API_BASE_URL}saveSection9LegalTeamDocuments`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setLnrFile(null);
        setSection9FinalFile(null);
        fetchData();

        // dono complete ho gaye to modal band, kyunki ab row is page pe rahegi hi nahi
        if (result.completed) {
          setShowLnrSection9Modal(false);
          setLnrSection9Item(null);
        }
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.error(err);
      toast.error('Upload failed');
    } finally {
      setLnrSection9Loading(false);
    }
  };

  const handleAction = async (agreementNo, action) => {
    try {
      const res = await fetch(`${config.API_BASE_URL}approverejectLegalAction`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          agreement_no: agreementNo,
          action,
          checker_id: userId,
        }),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(`Action ${action} successful`);
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Error processing action');
    }
  };

  const handleDownloadCourtOrder = (courtOrderFile) => {
    if (!courtOrderFile) {
      toast.error('Court order file not available');
      return;
    }

    const fileUrl = `${config.API_BASE_URL}${courtOrderFile}`;
    window.open(fileUrl, '_blank');
  };

  const handleUploadCourtOrder = async (agreementNo) => {
    const selectedFile = files[agreementNo];

    if (!selectedFile) {
      toast.error('Please select file');
      return;
    }

    const formData = new FormData();
    formData.append('agreement_no', agreementNo);
    formData.append('file', selectedFile);
    formData.append('user_id', userId);

    setPostLoading(true);

    try {
      const res = await fetch(`${config.API_BASE_URL}uploadCourtOrder`, {
        method: 'POST',
        body: formData,
      });

      const result = await res.json();

      if (result.status) {
        toast.success('Court order uploaded');
        setUploadingId(null);

        setFiles((prev) => {
          const updated = { ...prev };
          delete updated[agreementNo];
          return updated;
        });

        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Upload failed');
    } finally {
      setPostLoading(false);
    }
  };

  const handleCourtOrderAction = (agreementNo, action) => {
    setSelectedAgreement(agreementNo);
    setSelectedAction(action);
    setNotes('');
    setShowNotesModal(true);
  };

  const handleReuploadCourtOrder = (agreementNo) => {
    setReuploadAgreement(agreementNo);
    setResendNotes('');
    setShowReuploadModal(true);
  };

  const submitVehicleSurrender = async () => {
    if (!surrenderNote.trim()) {
      toast.error('Please enter note');
      return;
    }

    setPostLoading(true);

    try {
      const res = await fetch(`${config.API_BASE_URL}vehicleSurrender`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          agreement_no: selectedSurrenderAgreement,
          note: surrenderNote,
          user_id: userId,
        }),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);

        setShowSurrenderConfirmModal(false);
        setSurrenderNote('');
        setSelectedSurrenderAgreement('');

        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      toast.error('Something went wrong');
    } finally {
      // PRELOADER STOP
      setPostLoading(false);
    }
  };

  const handleSurrenderAction = (agreementNo, action) => {
    setSurrenderActionAgreement(agreementNo);
    setSurrenderAction(action);
    setSurrenderActionNote('');
    setShowSurrenderActionModal(true);
  };

  const submitSurrenderAction = async () => {
    if (!surrenderActionNote.trim()) {
      toast.error('Please enter note');
      return;
    }

    setSurrenderActionLoading(true);

    try {
      const payload = {
        agreement_no: surrenderActionAgreement,
        action: surrenderAction,
        notes: surrenderActionNote,
      };

      const res = await fetch(`${config.API_BASE_URL}approveRejectSurrender`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: encryptData(payload),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);
        setShowSurrenderActionModal(false);
        setSurrenderActionAgreement('');
        setSurrenderAction('');
        setSurrenderActionNote('');
        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      toast.error('Something went wrong');
    } finally {
      setSurrenderActionLoading(false);
    }
  };

  const repoFlowSteps = [
    'Pending',
    'Approved',
    'Pending for Court Order Review',
    'Court Order Approved',
    'Repo Initiated',
    'Repo Checklist Submitted',
    'Inspection Scheduled',
    'Inventory Created',
    'Yard Placement Pending',
    'Vehicle Yarded',
    'Ready For Listing Approval',
    'Listing Approved',
    'Live For Auction',
    'Auction Completed',
    'Case Closed',
  ];

  const logStepMap = {
    'legal action created': 1,
    'legal action approved': 2,
    'court order uploaded': 3,
    'court order approved': 4,
    'repo process initiated': 5,
    'repo checklist submitted': 6,
    'inspection scheduled': 7,
    'final inventory created': 8,
    'yard placement updated': 9,
    'vehicle yarded': 10,
    'ready for listing approval': 11,
    'listing approved': 12,
    'live for auction': 13,
    'auction completed': 14,
    'case closed': 15,
  };

  let currentStep = 1;

  if (activityLogs?.length > 0) {
    const sortedLogs = [...activityLogs].sort((a, b) => new Date(b.created_on) - new Date(a.created_on));

    sortedLogs.some((log) => {
      const matchedKey = Object.keys(logStepMap).find((key) =>
        log.log_description?.toLowerCase().includes(key.toLowerCase())
      );

      if (matchedKey) {
        currentStep = logStepMap[matchedKey];

        return true;
      }

      return false;
    });
  }

  // const filtered = visibleData.filter(item => {

  //   const status =
  //     item.legal_status || item.status || "";

  //   const matchesSearch =
  //     (item.AgreementNo || '')
  //       .toLowerCase()
  //       .includes(search.toLowerCase()) ||

  //     (item.contact_name || '')
  //       .toLowerCase()
  //       .includes(search.toLowerCase());

  //   const matchesStatus =
  //     !statusFilter ||
  //     status === statusFilter;

  //   return matchesSearch && matchesStatus;

  // });
  const filtered = visibleData;
  const handleExportExcel = () => {
    const headers = [
      'Sr No',
      'Agreement No',
      'Customer',
      'Phone',
      'DPD',
      'Status',
      'Notes',
      'Created By',
      'Updated By',
    ];

    const rows = data.map((item, index) => [
      index + 1,

      item.AgreementNo || '-',

      item.contact_name || '-',

      item.mobile || '-',

      item.DPDDays || '-',

      item.legal_status || item.status || 'Eligible',

      item.notes || '-',

      item.created_by_name || '-',

      item.updated_by_name || '-',
    ]);

    const csvContent = [
      headers.join(','),

      ...rows.map((row) => row.map((value) => `"${String(value).replace(/"/g, '""')}"`).join(',')),
    ].join('\n');

    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;',
    });

    const link = document.createElement('a');

    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);

    link.setAttribute('download', `Legal_Action_List_${Date.now()}.csv`);

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  const submitCourtOrderAction = async () => {
    if (!notes.trim()) {
      toast.error('Please enter notes');
      return;
    }

    try {
      // --- PRELOADER: show overlay before POST request ---
      setPostLoading(true);

      const res = await fetch(`${config.API_BASE_URL}approveRejectCourtOrder`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          agreement_no: selectedAgreement,
          action: selectedAction,
          checker_id: userId,
          notes,
        }),
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);

        setShowNotesModal(false);
        setNotes('');
        setSelectedAgreement('');
        setSelectedAction('');

        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Something went wrong');
    } finally {
      // --- PRELOADER: hide overlay after POST finishes ---
      setPostLoading(false);
    }
  };

  const submitReuploadCourtOrder = async () => {
    const selectedFile = files[reuploadAgreement];

    if (!selectedFile) {
      toast.error('Please select file');
      return;
    }

    if (!resendNotes.trim()) {
      toast.error('Please enter notes');
      return;
    }

    const formData = new FormData();

    formData.append('agreement_no', reuploadAgreement);
    formData.append('file', selectedFile);
    formData.append('user_id', userId);
    formData.append('notes', resendNotes);

    try {
      // --- PRELOADER: show overlay before POST request ---
      setPostLoading(true);

      const res = await fetch(`${config.API_BASE_URL}uploadCourtOrder`, {
        method: 'POST',
        body: formData,
      });

      const result = await res.json();

      if (result.status) {
        toast.success(result.message);

        setShowReuploadModal(false);
        setReuploadAgreement('');
        setResendNotes('');

        fetchData();
      } else {
        toast.error(result.message);
      }
    } catch {
      toast.error('Upload failed');
    } finally {
      // --- PRELOADER: hide overlay after POST finishes ---
      setPostLoading(false);
    }
  };

  // Generates a smart page range like: 1, '...', 4, 5, 6, 7, 8, '...', 77
  const getPaginationRange = (current, total, siblingCount = 1) => {
    const totalPageNumbers = siblingCount * 2 + 5; // first, last, current, 2*ellipsis, siblings

    if (totalPageNumbers >= total) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const leftSiblingIndex = Math.max(current - siblingCount, 1);
    const rightSiblingIndex = Math.min(current + siblingCount, total);

    const showLeftDots = leftSiblingIndex > 2;
    const showRightDots = rightSiblingIndex < total - 1;

    const firstPageIndex = 1;
    const lastPageIndex = total;

    if (!showLeftDots && showRightDots) {
      const leftItemCount = 3 + 2 * siblingCount;
      const leftRange = Array.from({ length: leftItemCount }, (_, i) => i + 1);
      return [...leftRange, '...', total];
    }

    if (showLeftDots && !showRightDots) {
      const rightItemCount = 3 + 2 * siblingCount;
      const rightRange = Array.from({ length: rightItemCount }, (_, i) => total - rightItemCount + i + 1);
      return [firstPageIndex, '...', ...rightRange];
    }

    if (showLeftDots && showRightDots) {
      const middleRange = Array.from(
        { length: rightSiblingIndex - leftSiblingIndex + 1 },
        (_, i) => leftSiblingIndex + i
      );
      return [firstPageIndex, '...', ...middleRange, '...', lastPageIndex];
    }

    return [];
  };

  // 📄 PAGINATION
  // const start = (page - 1) * perPage;
  // const paginated = filtered.slice(start, start + perPage);
  // const totalPages = Math.ceil(filtered.length / perPage);

  return (
    <Container>
      <style>
        {`
      @keyframes blinkStatus{
        0%{
            opacity:1;
        }

        50%{
            opacity:.35;
        }

        100%{
            opacity:1;
        }
      }
      `}
      </style>
      {/* --- PRELOADER OVERLAY: shown during POST request --- */}
      {postLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255,255,255,0.85)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(3px)',
          }}
        >
          <div
            style={{
              width: '56px',
              height: '56px',
              border: '5px solid #e0e0e0',
              borderTop: '5px solid #1976d2',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite',
            }}
          />
          <p style={{ marginTop: '18px', fontWeight: 600, color: '#1976d2', fontSize: '15px' }}>
            Processing, please wait...
          </p>
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                width: '320px',
                height: '14px',
                borderRadius: '6px',
                marginTop: '10px',
                background: 'linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)',
                backgroundSize: '400% 100%',
                animation: 'shimmer 1.4s infinite',
              }}
            />
          ))}
          <style>{`
              @keyframes spin { to { transform: rotate(360deg); } }
              @keyframes shimmer { 0%{background-position:100% 0} 100%{background-position:-100% 0} }
            `}</style>
        </div>
      )}
      {/* --- END PRELOADER OVERLAY --- */}

      <div className="d-flex justify-content-between align-items-center mb-3">
        <Typography variant="h4">Eligible Loans for Legal Action</Typography>
      </div>

      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-success"
          onClick={handleExportExcel}
          style={{
            fontSize: '12px',
            padding: '6px 14px',
          }}
        >
          ⬇ Export Excel
        </button>
      </div>

      {/* SEARCH */}
      <div className="row mb-3">
        <div className="col-md-3">
          <select
            className="form-select"
            value={statusFilter}
            // onChange={(e) =>
            //   setStatusFilter(e.target.value)
            // }
            onChange={(e) => {
              setStatusFilter(e.target.value);
              setPage(1);
            }}
          >
            <option value="">All Status</option>

            {allowedStatuses.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4 ms-auto">
          <input
            type="text"
            className="form-control"
            placeholder="Search Agreement / Customer..."
            value={search}
            // onChange={(e) => setSearch(e.target.value)}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
          />
        </div>
      </div>

      {/* TABLE */}
      <div className="table-wrap">
        <table className="table table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th style={{ width: '40px' }} />
              <th>#</th>
              <th>Agreement No</th>
              <th>Customer</th>
              <th>Phone</th>
              <th>DPD</th>
              <th>Status</th>
              <th width="220">Action</th>
              <th width="120">All Activities</th>
            </tr>
          </thead>

          <tbody>
            {/* {paginated.map((item, index) => { */}
            {filtered.map((item, index) => {
              const status = item.legal_status || item.status || 'Eligible';
              const isExpanded = expandedRow === item.AgreementNo;
              return (
                <tr
                  key={item.AgreementNo}
                  style={{ cursor: 'pointer' }}
                  onClick={() => setExpandedRow(isExpanded ? null : item.AgreementNo)}
                >
                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    <span
                      style={{
                        display: 'inline-block',
                        transition: 'transform 0.25s',
                        transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                        fontSize: '16px',
                        color: '#555',
                      }}
                    >
                      &#8250;
                    </span>
                  </td>
                  {/* <td>{start + index + 1}</td> */}
                  <td>{(page - 1) * 10 + index + 1}</td>
                  <td>
                    <Link
                      to={`/dashboard/allcloud-loans-report/${btoa(String(item.id))}/${btoa(String(item.AgreementNo))}`}
                      style={{ color: '#0d6efd', textDecoration: 'underline' }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {item.AgreementNo}
                    </Link>
                  </td>
                  <td>{item.contact_name || '-'}</td>
                  <td>{item.mobile || '-'}</td>
                  <td>{item.DPDDays}</td>

                  {/* STATUS */}
                  <td>
                    {!status && <span className="badge bg-warning text-dark">Eligible</span>}

                    {status === 'Pending' && <span className="badge bg-secondary">Waiting</span>}

                    {status === 'Approved' && <span className="badge bg-success">Approved</span>}

                    {status === 'Rejected' && <span className="badge bg-danger">Rejected</span>}

                    {status === 'Pending for Court Order Review' && (
                      <span className="badge bg-warning text-dark">Court Order Uploaded</span>
                    )}

                    {status === 'Court Order Approved' && (
                      <span className="badge bg-success">Court Order Approved</span>
                    )}

                    {status === 'Court Order Rejected' && <span className="badge bg-danger">Court Order Rejected</span>}

                    {status === 'Repo Initiated' && <span className="badge bg-info text-dark">Repo Initiated</span>}

                    {status === 'Repo Checklist Submitted' && (
                      <span className="badge bg-primary">Repo Checklist Submitted</span>
                    )}
                    {status === 'Section 9 Initiated' && ( // 👈 add karo
                      <span className="badge bg-warning text-dark">Section 9 Initiated</span>
                    )}
                    {status === 'Section 138 Initiated' && (
                      <span className="badge" style={{ background: '#6f42c1', color: '#fff' }}>
                        Section 138 Initiated
                      </span>
                    )}
                    {status === 'Requested To Legal Team For Section 138' && (
                      <span
                        className="badge"
                        style={{
                          background: '#6f42c1',
                          color: '#fff',
                          animation: 'blinkStatus 2s infinite',
                        }}
                      >
                        Requested To Legal Team For Section 138
                      </span>
                    )}
                    {status === 'Forwarded to Legal Team' && (
                      <span
                        className="badge"
                        style={{
                          background: '#dc3545',
                          color: '#fff',
                          animation: 'blinkStatus 2s infinite',
                        }}
                      >
                        Forwarded To Legal Team For Section 9
                      </span>
                    )}
                    {status === 'Section 138 Legal Team Reviewed' && (
                      <span
                        className="badge"
                        style={{
                          background: '#45a0ec',
                          color: '#fff',
                        }}
                      >
                        Section 138 Legal Team Reviewed
                      </span>
                    )}
                    {status === 'LEGAL_LETTER_INITIATED' && (
                      <span className="badge" style={{ background: '#0dcaf0', color: '#fff' }}>
                        Legal Letter Initiated
                      </span>
                    )}
                    {status === 'LEGAL_LETTER_FORWARDED_TO_LEGAL_TEAM' && (
                      <span
                        className="badge"
                        style={{ background: '#fd7e14', color: '#fff', animation: 'blinkStatus 2s infinite' }}
                      >
                        Legal Letter Forwarded To Legal Team
                      </span>
                    )}
                    {status === 'LEGAL_LETTER_REVIEWED' && (
                      <span className="badge" style={{ background: '#20c997', color: '#fff' }}>
                        Legal Letter Reviewed
                      </span>
                    )}
                    {status === 'LEGAL_LETTER_COMPLETED' && (
                      <span className="badge" style={{ background: '#198754', color: '#fff' }}>
                        Legal Letter Completed
                      </span>
                    )}
                    {status === 'Pending Surrender Approval' && (
                      <span
                        className="badge"
                        style={{ background: '#C41E3A', color: '#fff', animation: 'blinkStatus 2s infinite' }}
                      >
                        Sent for Surrender Approval
                      </span>
                    )}
                    {status === 'Surrender Rejected' && <span className="badge bg-danger">Surrender Rejected</span>}
                    {status === 'Vehicle Surrender' && (
                      <span className="badge" style={{ background: '#198754', color: '#fff' }}>
                        Vehicle Surrendered
                      </span>
                    )}
                  </td>

                  <td onClick={(e) => e.stopPropagation()}>
                    {/* REJECTED */}
                    {status === 'Rejected' && (
                      <div className="d-flex flex-column gap-1">
                        {isExpanded && (
                          <span className="text-danger d-block">Rejected by {item.updated_by_name || 'User'}</span>
                        )}

                        {/* Only Maker/Admin */}
                        {(isMaker || isAdmin) && (
                          <button
                            className="btn btn-sm btn-warning"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                            }}
                            onClick={() => {
                              console.log('ITEM DPD:', item.DPDDays, typeof item.DPDDays);
                              setLegalOptionsAgreement(item.AgreementNo);
                              setLegalOptionsDpd(item.DPDDays);
                              setShowLegalOptionsModal(true);
                            }}
                          >
                            Legal
                          </button>
                        )}

                        {/* Maker + Checker + Admin */}
                        <button
                          className="btn btn-sm btn-info"
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                          }}
                          onClick={() => navigate(`/dashboard/common-due-letter/${btoa(String(item.AgreementNo))}`)}
                        >
                          Generate Over-Due Letter
                        </button>
                      </div>
                    )}

                    {/* NEW CASE (no record yet) */}
                    {/* {(isMaker || isAdmin) && !item.legal_status && (
                    <button
                      className="btn btn-sm btn-warning"
                      style={{
                        padding: "4px 10px",
                        fontSize: "9px",
                        textTransform: "capitalize"
                      }}
                      onClick={() => handleSendForApproval(item.AgreementNo)}
                    >
                      Legal
                    </button>
                  )} */}

                    {/* SURRENDER — PENDING APPROVAL */}
                    {status === 'Pending Surrender Approval' && (
                      <div className="d-flex flex-column gap-1">
                        {isExpanded && (
                          <small className="text-danger d-block mb-1">
                            Sent for Surrender Approval by {item.created_by_name || item.updated_by_name || 'User'}
                          </small>
                        )}

                        {(isChecker || isAdmin) && (
                          <>
                            <button
                              className="btn btn-sm btn-success me-2"
                              style={{
                                height: '23px',
                                borderRadius: '5px',
                                padding: '5px 7px',
                                fontSize: '8.2px',
                                minWidth: '90px',
                                fontWeight: 'normal',
                              }}
                              onClick={() => handleSurrenderAction(item.AgreementNo, 'approve')}
                            >
                              ✓ Accept
                            </button>

                            <button
                              className="btn btn-sm btn-danger"
                              style={{
                                height: '23px',
                                borderRadius: '5px',
                                padding: '5px 7px',
                                fontSize: '8.2px',
                                minWidth: '90px',
                                fontWeight: 'normal',
                              }}
                              onClick={() => handleSurrenderAction(item.AgreementNo, 'reject')}
                            >
                              ✕ Reject
                            </button>
                          </>
                        )}

                        {isMaker && !isChecker && !isAdmin && (
                          <span className="text-warning" style={{ fontSize: '12px', fontWeight: '600' }}>
                            Waiting for Surrender Approval by Credit Team
                          </span>
                        )}

                        {/* NOTE — only visible when row is expanded, appears below Accept/Reject buttons */}
                        {isExpanded && item.notes && (
                          <div
                            style={{
                              marginTop: '8px',
                              maxWidth: '260px',
                            }}
                          >
                            <div
                              style={{
                                fontSize: '13px',
                                color: '#6c757d',
                                lineHeight: '1.5',
                                wordBreak: 'break-word',
                                overflow: 'hidden',
                                display: '-webkit-box',
                                WebkitLineClamp: expandedNotes[`${item.AgreementNo}_surrender`] ? 'none' : 2,
                                WebkitBoxOrient: 'vertical',
                              }}
                            >
                              <strong>Notes:</strong> {item.notes}
                            </div>

                            {item.notes.length > 15 && (
                              <button
                                type="button"
                                onClick={() =>
                                  setExpandedNotes((prev) => ({
                                    ...prev,
                                    [`${item.AgreementNo}_surrender`]: !prev[`${item.AgreementNo}_surrender`],
                                  }))
                                }
                                style={{
                                  color: '#0d6efd',
                                  fontSize: '12px',
                                  fontWeight: '600',
                                  cursor: 'pointer',
                                  marginTop: '4px',
                                  display: 'inline-block',
                                  background: 'transparent',
                                  border: 'none',
                                  padding: 0,
                                }}
                              >
                                {expandedNotes[`${item.AgreementNo}_surrender`] ? 'See Less' : 'See More'}
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    )}

                    {/* SURRENDER — REJECTED */}
                    {status === 'Surrender Rejected' && isExpanded && (
                      <div className="d-flex flex-column gap-1">
                        <span className="text-danger d-block">
                          Surrender Rejected by {item.updated_by_name || 'Credit Operations'}
                        </span>
                        <div style={{ fontSize: '13px', color: '#6c757d' }}>
                          <strong>Notes:</strong> {item.notes}
                        </div>
                      </div>
                    )}

                    {!item.legal_status && (
                      <div className="d-flex flex-column gap-1">
                        {(isMaker || isAdmin) && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'uppercase',
                              backgroundColor: '#C41E3A',
                              borderColor: '#C41E3A',
                              color: '#fff',
                              fontWeight: '600',
                            }}
                            onClick={() => {
                              setSelectedSurrenderAgreement(item.AgreementNo);
                              setShowSurrenderConfirmModal(true);
                            }}
                          >
                            Surrender
                          </button>
                        )}

                        {/* Sirf Maker/Admin ke liye */}
                        {(isMaker || isAdmin) && (
                          <button
                            className="btn btn-sm btn-warning"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                            onClick={() => {
                              console.log('ITEM DPD:', item.DPDDays, typeof item.DPDDays);
                              setLegalOptionsAgreement(item.AgreementNo);
                              setLegalOptionsDpd(item.DPDDays);
                              setShowLegalOptionsModal(true);
                            }}
                          >
                            Legal
                          </button>
                        )}

                        {/* Maker + Checker + Admin sabko dikhana hai */}
                        {(isMaker || isChecker || isAdmin) && (
                          <button
                            className="btn btn-sm btn-info"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                            onClick={() => navigate(`/dashboard/common-due-letter/${btoa(String(item.AgreementNo))}`)}
                          >
                            Generate Over-Due Letter
                          </button>
                        )}
                      </div>
                    )}

                    {status === 'Section 9 Initiated' && (
                      <>
                        {/* MAKER VIEW */}
                        {isExpanded && isMaker && !isChecker && (
                          <div className="d-flex flex-column gap-1">
                            <small className="text-warning d-block mb-1">Section 9 submitted to Credit Team</small>

                            <small className="text-success d-block">
                              Submitted By : {item.created_by_name || 'User'}
                            </small>

                            <button
                              className="btn btn-sm btn-outline-primary"
                              style={{
                                padding: '4px 10px',
                                fontSize: '9px',
                                textTransform: 'capitalize',
                                width: 'fit-content',
                              }}
                              onClick={() => handleViewMakerDetails(item.AgreementNo)}
                            >
                              👁 View Maker Details
                            </button>
                          </div>
                        )}

                        {/* CHECKER VIEW — Forward button hamesha dikhega */}
                        {isChecker && (
                          <div className="d-flex flex-column gap-1">
                            {isExpanded && (
                              <>
                                <small className="text-primary d-block mb-1">Section 9 request received</small>
                                <small className="text-success d-block mb-1">
                                  Submitted By : {item.created_by_name || 'User'}
                                </small>

                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  style={{
                                    padding: '4px 10px',
                                    fontSize: '9px',
                                    textTransform: 'capitalize',
                                    width: 'fit-content',
                                  }}
                                  onClick={() => handleViewMakerDetails(item.AgreementNo)}
                                >
                                  👁 View Maker Details
                                </button>
                              </>
                            )}

                            <button
                              className="btn btn-sm"
                              style={{
                                padding: '4px 10px',
                                fontSize: '9px',
                                textTransform: 'capitalize',
                                backgroundColor: '#ee4bad',
                                color: '#fff',
                              }}
                              onClick={() => {
                                setForwardToLegalAgreement(item.AgreementNo);
                                setShowForwardToLegalModal(true);
                              }}
                            >
                              Verify & Forward to Legal Team
                            </button>
                          </div>
                        )}
                      </>
                    )}

                    {status === 'Forwarded to Legal Team' && (
                      <div className="d-flex flex-column gap-1">
                        {isExpanded && (
                          <>
                            <small
                              style={{ color: '#dc3545', fontWeight: '600', animation: 'blinkStatus 2s infinite' }}
                            >
                              {getForwardedBadgeText(item)}
                            </small>
                            <small className="text-success">
                              Forwarded By :{item.updated_by_name || 'Credit Operations'}
                            </small>
                            <button
                              className="btn btn-sm btn-outline-primary"
                              style={{ padding: '4px 10px', fontSize: '9px', width: 'fit-content' }}
                              onClick={() => handleViewLegalForwardDetails(item.AgreementNo)}
                            >
                              View Details
                            </button>
                          </>
                        )}

                        {/* 👇 NAYA — sabko hamesha dikhega (legal team chhodkar), expand ki zaroorat nahi */}
                        {!isLegalTeam && (
                          <>
                            {item.lnr_document ? (
                              <div
                                className="d-flex align-items-center gap-2 mt-1"
                                style={{
                                  background: '#f0fdf4',
                                  border: '1px solid #bbf7d0',
                                  borderRadius: '8px',
                                  padding: '6px 10px',
                                  width: 'fit-content',
                                }}
                              >
                                <a
                                  href={config.API_BASE_URL + item.lnr_document}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn btn-sm btn-success"
                                  style={{ padding: '3px 10px', fontSize: '9px', fontWeight: 700 }}
                                >
                                  View LNR
                                </a>
                                <small style={{ fontSize: '11px', color: '#166534', fontWeight: 600 }}>
                                  by {item.lnr_uploaded_by_name || 'Legal Team'}
                                </small>
                              </div>
                            ) : null}

                            {item.section9_final_document ? (
                              <div
                                className="d-flex align-items-center gap-2 mt-1"
                                style={{
                                  background: '#eff6ff',
                                  border: '1px solid #bfdbfe',
                                  borderRadius: '8px',
                                  padding: '6px 10px',
                                  width: 'fit-content',
                                }}
                              >
                                <a
                                  href={config.API_BASE_URL + item.section9_final_document}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn btn-sm btn-primary"
                                  style={{ padding: '3px 10px', fontSize: '9px', fontWeight: 700 }}
                                >
                                  View Section 9
                                </a>
                                <small style={{ fontSize: '11px', color: '#1e40af', fontWeight: 600 }}>
                                  by {item.section9_uploaded_by_name || 'Legal Team'}
                                </small>
                              </div>
                            ) : null}
                          </>
                        )}

                        {isLegalTeam ? (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              fontWeight: 700,
                              backgroundColor: getLnrSection9ButtonConfig(item).bg,
                              color: '#fff',
                              border: 'none',
                              borderRadius: '6px',
                              animation: getLnrSection9ButtonConfig(item).blink ? 'blinkStatus 1.6s infinite' : 'none',
                              width: 'fit-content',
                            }}
                            onClick={() => {
                              setLnrSection9Item(item);
                              setShowLnrSection9Modal(true);
                            }}
                          >
                            {getLnrSection9ButtonConfig(item).text}
                          </button>
                        ) : null}
                      </div>
                    )}

                    {status === 'Pending' && (
                      <>
                        {isExpanded && (
                          <small className="text-primary d-block mb-1">
                            Sent for Approval by{' '}
                            {item.updated_by_name && item.notes ? item.updated_by_name : item.created_by_name || 'User'}
                          </small>
                        )}

                        {isChecker && (
                          <>
                            <button
                              className="btn btn-sm btn-success me-2"
                              style={{
                                height: '23px',
                                borderRadius: '5px',
                                padding: '5px 7px',
                                fontSize: '8.2px',
                                minWidth: '90px',
                                fontWeight: 'normal',
                              }}
                              onClick={() => handleAction(item.AgreementNo, 'approve')}
                            >
                              ✓ Accept
                            </button>

                            <button
                              className="btn btn-sm btn-danger"
                              style={{
                                height: '23px',
                                borderRadius: '5px',
                                padding: '5px 7px',
                                fontSize: '8.2px',
                                minWidth: '90px',
                                fontWeight: 'normal',
                              }}
                              onClick={() => handleAction(item.AgreementNo, 'reject')}
                            >
                              ✕ Reject
                            </button>
                          </>
                        )}
                      </>
                    )}

                    {/* APPROVED — Maker uploads court order file */}
                    {status === 'Approved' && (isChecker || isAdmin) && (
                      <div className="mt-1">
                        {uploadingId === item.AgreementNo ? (
                          <div>
                            <label
                              className="form-label fw-bold mb-1"
                              style={{
                                fontSize: '12px',
                                color: '#0d6efd',
                              }}
                            >
                              Upload LNR
                            </label>

                            <input
                              type="file"
                              className="form-control form-control-sm mb-1"
                              accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                              onChange={(e) =>
                                setFiles((prev) => ({
                                  ...prev,
                                  [item.AgreementNo]: e.target.files[0],
                                }))
                              }
                            />

                            <button
                              className="btn btn-sm btn-success me-1"
                              onClick={() => handleUploadCourtOrder(item.AgreementNo)}
                            >
                              Upload
                            </button>

                            <button className="btn btn-sm btn-secondary" onClick={() => setUploadingId(null)}>
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <button
                            className="btn btn-sm btn-primary"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                            onClick={() => setUploadingId(item.AgreementNo)}
                          >
                            Upload Court Order
                          </button>
                        )}
                      </div>
                    )}
                    {status === 'Approved' && isMaker && !isChecker && (
                      <div className="mt-1">
                        <span
                          className="text-warning"
                          style={{
                            fontSize: '12px',
                            fontWeight: '600',
                          }}
                        >
                          Waiting for Court Order Upload by Credit Team
                        </span>
                      </div>
                    )}

                    {status === 'Pending for Court Order Review' && isChecker && (
                      <div className="d-flex flex-column gap-1">
                        {isExpanded && (
                          <>
                            <small className="text-primary d-block mb-1">
                              Sent for Court Order Approval by{' '}
                              {item.updated_by_name && item.notes
                                ? item.updated_by_name
                                : item.created_by_name || 'User'}
                            </small>

                            <button
                              type="button"
                              onClick={() => handleDownloadCourtOrder(item.court_order_file)}
                              style={{
                                border: 'none',
                                background: 'transparent',
                                padding: '0',
                                width: 'fit-content',
                                color: '#0dcaf0',
                                cursor: 'pointer',
                                fontSize: '13px',
                                fontWeight: '600',
                                textDecoration: 'underline',
                              }}
                            >
                              ⬇ Download Court Order
                            </button>

                            {item.notes && (
                              <button
                                type="button"
                                title="View re-upload notes from maker"
                                onClick={() => {
                                  setViewNotesContent(item.notes);
                                  setShowViewNotesModal(true);
                                }}
                                style={{
                                  border: 'none',
                                  background: 'transparent',
                                  padding: '0',
                                  width: 'fit-content',
                                  color: '#6c757d',
                                  cursor: 'pointer',
                                  fontSize: '12px',
                                  fontWeight: '500',
                                  textDecoration: 'underline',
                                }}
                              >
                                👁 View Notes
                              </button>
                            )}
                          </>
                        )}

                        <button
                          className="btn btn-success btn-sm"
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                          onClick={() => handleCourtOrderAction(item.AgreementNo, 'approve')}
                        >
                          ✓ Approve Court Order
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                          onClick={() => handleCourtOrderAction(item.AgreementNo, 'reject')}
                        >
                          ✕ Reject Court Order
                        </button>
                      </div>
                    )}

                    {status === 'Pending for Court Order Review' && !isChecker && isExpanded && (
                      <span className="text-warning d-block mt-1">Waiting for Court Order Approval</span>
                    )}

                    {status === 'Court Order Approved' && !isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-success d-block">
                              Court Order Approved by {item.updated_by_name || 'Credit Operations'}
                            </span>

                            <div
                              style={{
                                marginTop: '8px',
                                maxWidth: '260px',
                              }}
                            >
                              <div
                                style={{
                                  fontSize: '13px',
                                  color: '#6c757d',
                                  lineHeight: '1.5',
                                  wordBreak: 'break-word',
                                  overflow: 'hidden',
                                  display: '-webkit-box',
                                  WebkitLineClamp: expandedNotes[item.AgreementNo] ? 'none' : 2,
                                  WebkitBoxOrient: 'vertical',
                                }}
                              >
                                <strong>Notes:</strong> {item.notes}
                              </div>

                              {item.notes && item.notes.length > 15 && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    setExpandedNotes((prev) => ({
                                      ...prev,
                                      [item.AgreementNo]: !prev[item.AgreementNo],
                                    }))
                                  }
                                  style={{
                                    color: '#0d6efd',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    marginTop: '4px',
                                    display: 'inline-block',
                                    background: 'transparent',
                                    border: 'none',
                                    padding: 0,
                                  }}
                                >
                                  {expandedNotes[item.AgreementNo] ? 'Read Less' : 'Read More'}
                                </button>
                              )}
                            </div>
                          </>
                        )}

                        <button
                          className="btn btn-sm btn-primary mt-2"
                          onClick={() => {
                            if (!allowedRepoUsers.includes(userRole?.toLowerCase())) {
                              toast.error('Access Denied');

                              return;
                            }

                            navigate(`/dashboard/create-vehicle-repo/${btoa(String(item.AgreementNo))}`);
                          }}
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                        >
                          START REPO PROCESS
                        </button>
                      </div>
                    )}

                    {status === 'Repo Initiated' && !isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-info d-block">Repo process initiated successfully</span>
                            <small className="text-success d-block mt-1">
                              Submitted By: {item.updated_by_name || 'User'}
                            </small>

                            <div
                              style={{
                                marginTop: '6px',
                                maxWidth: '260px',
                              }}
                            >
                              <div
                                style={{
                                  fontSize: '13px',
                                  color: '#6c757d',
                                  lineHeight: '1.5',
                                  wordBreak: 'break-word',
                                  overflow: 'hidden',
                                  display: '-webkit-box',
                                  WebkitLineClamp: expandedNotes[item.AgreementNo] ? 'none' : 2,
                                  WebkitBoxOrient: 'vertical',
                                }}
                              >
                                <strong>Notes:</strong> {item.notes}
                              </div>

                              {item.notes && item.notes.length > 15 && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    setExpandedNotes((prev) => ({
                                      ...prev,
                                      [`${item.AgreementNo}_repo`]: !prev[`${item.AgreementNo}_repo`],
                                    }))
                                  }
                                  style={{
                                    color: '#0d6efd',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    marginTop: '4px',
                                    display: 'inline-block',
                                    background: 'transparent',
                                    border: 'none',
                                    padding: 0,
                                  }}
                                >
                                  {expandedNotes[`${item.AgreementNo}_repo`] ? 'Read Less' : 'Read More'}
                                </button>
                              )}
                            </div>
                          </>
                        )}

                        <button
                          className="btn btn-sm btn-dark mt-2"
                          onClick={() => {
                            if (!allowedRepoUsers.includes(userRole?.toLowerCase())) {
                              toast.error('Access Denied');

                              return;
                            }

                            navigate(`/dashboard/repo-conditions-checklist/${item.repo_id}`);
                          }}
                          style={{
                            padding: '4px 10px',
                            fontSize: '9px',
                            textTransform: 'capitalize',
                          }}
                        >
                          OPEN REPO CHECKLIST
                        </button>
                      </div>
                    )}
                    {status === 'Repo Checklist Submitted' && !isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-success d-block">Repo checklist submitted successfully</span>

                            <small className="text-success d-block mt-1">
                              Submitted By: {item.updated_by_name || 'User'}
                            </small>

                            <small className="text-muted d-block mt-1">Inspection / Yard placement pending</small>
                          </>
                        )}

                        <div className="d-flex gap-2 flex-wrap mt-2">
                          <button
                            className="btn btn-sm btn-dark"
                            onClick={() => {
                              navigate(`/dashboard/view-repo-checklist/${item.repo_id}`);
                            }}
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                          >
                            View Checklist
                          </button>

                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => {
                              if (!allowedRepoUsers.includes(userRole?.toLowerCase())) {
                                toast.error('Access Denied');
                                return;
                              }

                              navigate(`/dashboard/schedule-inspection/${item.repo_id}`);
                            }}
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                          >
                            Open schedule Inspection
                          </button>
                        </div>
                      </div>
                    )}

                    {status === 'Section 138 Initiated' && (
                      <div className="d-flex flex-column gap-1">
                        {isExpanded && (
                          <>
                            <small className="text-success d-block mb-1">
                              Submitted By : {item.updated_by_name || item.created_by_name || 'User'}
                            </small>

                            <div style={{ marginTop: '4px', maxWidth: '260px' }}>
                              <div
                                style={{
                                  fontSize: '13px',
                                  color: '#6c757d',
                                  lineHeight: '1.5',
                                  wordBreak: 'break-word',
                                  overflow: 'hidden',
                                  display: '-webkit-box',
                                  WebkitLineClamp: expandedNotes[`${item.AgreementNo}_138`] ? 'none' : 2,
                                  WebkitBoxOrient: 'vertical',
                                }}
                              >
                                <strong>Note:</strong> {item.notes}
                              </div>

                              {item.notes && item.notes.length > 15 && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    setExpandedNotes((prev) => ({
                                      ...prev,
                                      [`${item.AgreementNo}_138`]: !prev[`${item.AgreementNo}_138`],
                                    }))
                                  }
                                  style={{
                                    color: '#0d6efd',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    marginTop: '4px',
                                    display: 'inline-block',
                                    background: 'transparent',
                                    border: 'none',
                                    padding: 0,
                                  }}
                                >
                                  {expandedNotes[`${item.AgreementNo}_138`] ? 'Read Less' : 'Read More'}
                                </button>
                              )}
                            </div>
                          </>
                        )}

                        {/* Button hamesha visible rahega, accordion state se independent */}
                        {isChecker && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                              backgroundColor: '#6f42c1',
                              borderColor: '#6f42c1',
                              color: '#fff',
                              fontWeight: 700,
                              width: 'fit-content',
                            }}
                            onClick={() => {
                              setRequestLegalSection138Agreement(item.AgreementNo);
                              setShowRequestLegalSection138Modal(true);
                            }}
                          >
                            Request to Legal Team
                          </button>
                        )}
                      </div>
                    )}

                    {status === 'Requested To Legal Team For Section 138' && (
                      <div className="d-flex flex-column gap-1">
                        {isExpanded && (
                          <small className="text-success d-block mb-1">
                            Submitted By : {item.updated_by_name || item.created_by_name || 'User'}
                          </small>
                        )}

                        {/* View Documents — hamesha visible, checker + maker + legal team sabko */}
                        {(isChecker || isMaker || isLegalTeam) && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                              backgroundColor: '#0d6efd',
                              borderColor: '#0d6efd',
                              color: '#fff',
                              fontWeight: 700,
                              width: 'fit-content',
                            }}
                            onClick={() => handleViewSection138Documents(item.AgreementNo)}
                          >
                            📄 View Documents
                          </button>
                        )}

                        {/* Next Step — sirf Legal Team ko */}
                        {isLegalTeam && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                              backgroundColor: '#6f42c1',
                              borderColor: '#6f42c1',
                              color: '#fff',
                              fontWeight: 700,
                              width: 'fit-content',
                            }}
                            onClick={() => {
                              setSection138NextStepAgreement(item.AgreementNo);
                              setShowSection138NextStepModal(true);
                            }}
                          >
                            Next Step
                          </button>
                        )}
                      </div>
                    )}

                    {status === 'Section 138 Legal Team Reviewed' && (
                      <div className="d-flex flex-column gap-1">
                        {isExpanded && (
                          <small className="text-success d-block mb-1">
                            Submitted By : {item.updated_by_name || item.created_by_name || 'User'}
                          </small>
                        )}

                        {/* View Documents — hamesha visible, checker + maker + legal team sabko */}
                        {(isChecker || isMaker || isLegalTeam) && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                              backgroundColor: '#0d6efd',
                              borderColor: '#0d6efd',
                              color: '#fff',
                              fontWeight: 700,
                              width: 'fit-content',
                            }}
                            onClick={() => handleViewSection138Documents(item.AgreementNo)}
                          >
                            📄 View Documents
                          </button>
                        )}

                        {/* Next Step — sirf Legal Team ko, wahi purana modal reuse ho raha hai */}
                        {isLegalTeam && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                              backgroundColor: '#6f42c1',
                              borderColor: '#6f42c1',
                              color: '#fff',
                              fontWeight: 700,
                              width: 'fit-content',
                            }}
                            onClick={() => {
                              setSection138NextStepAgreement(item.AgreementNo);
                              setShowSection138NextStepModal(true);
                            }}
                          >
                            Next Step
                          </button>
                        )}
                      </div>
                    )}

                    {status === 'LEGAL_LETTER_INITIATED' && (
                      <div className="d-flex flex-column gap-1">
                        {isExpanded && (
                          <>
                            <small className="text-primary d-block mb-1">Legal Letter submitted to Credit Team</small>
                            <small className="text-success d-block mb-1">
                              Submitted By : {item.created_by_name || item.updated_by_name || 'User'}
                            </small>
                            <div style={{ marginTop: '4px', maxWidth: '260px' }}>
                              <div
                                style={{
                                  fontSize: '13px',
                                  color: '#6c757d',
                                  lineHeight: '1.5',
                                  wordBreak: 'break-word',
                                  overflow: 'hidden',
                                  display: '-webkit-box',
                                  WebkitLineClamp: expandedNotes[`${item.AgreementNo}_ll`] ? 'none' : 2,
                                  WebkitBoxOrient: 'vertical',
                                }}
                              >
                                <strong>Note:</strong> {item.notes}
                              </div>
                              {item.notes && item.notes.length > 15 && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    setExpandedNotes((prev) => ({
                                      ...prev,
                                      [`${item.AgreementNo}_ll`]: !prev[`${item.AgreementNo}_ll`],
                                    }))
                                  }
                                  style={{
                                    color: '#0d6efd',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    marginTop: '4px',
                                    display: 'inline-block',
                                    background: 'transparent',
                                    border: 'none',
                                    padding: 0,
                                  }}
                                >
                                  {expandedNotes[`${item.AgreementNo}_ll`] ? 'Read Less' : 'Read More'}
                                </button>
                              )}
                            </div>
                          </>
                        )}

                        {isChecker && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                              backgroundColor: '#0dcaf0',
                              borderColor: '#0dcaf0',
                              color: '#fff',
                              fontWeight: 700,
                              width: 'fit-content',
                            }}
                            onClick={() => {
                              setLegalLetterUploadAgreement(item.AgreementNo);
                              setShowLegalLetterUploadModal(true);
                            }}
                          >
                            Upload Review Details
                          </button>
                        )}
                      </div>
                    )}

                    {status === 'LEGAL_LETTER_FORWARDED_TO_LEGAL_TEAM' && (
                      <div className="d-flex flex-column gap-1">
                        {isExpanded && (
                          <small className="text-success d-block mb-1">
                            Submitted By : {item.updated_by_name || item.created_by_name || 'User'}
                          </small>
                        )}

                        {(isChecker || isMaker || isLegalTeam) && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                              backgroundColor: '#0d6efd',
                              borderColor: '#0d6efd',
                              color: '#fff',
                              fontWeight: 700,
                              width: 'fit-content',
                            }}
                            onClick={() => handleViewLegalLetterDocuments(item.AgreementNo)}
                          >
                            📄 View Documents
                          </button>
                        )}

                        {isLegalTeam && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                              backgroundColor: '#fd7e14',
                              borderColor: '#fd7e14',
                              color: '#fff',
                              fontWeight: 700,
                              width: 'fit-content',
                            }}
                            onClick={() => {
                              setLegalLetterNextStepAgreement(item.AgreementNo);
                              setShowLegalLetterNextStepModal(true);
                            }}
                          >
                            Next Step
                          </button>
                        )}
                      </div>
                    )}

                    {status === 'LEGAL_LETTER_REVIEWED' && (
                      <div className="d-flex flex-column gap-1">
                        {isExpanded && (
                          <small className="text-success d-block mb-1">
                            Submitted By : {item.updated_by_name || item.created_by_name || 'User'}
                          </small>
                        )}

                        {(isChecker || isMaker || isLegalTeam) && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                              backgroundColor: '#0d6efd',
                              borderColor: '#0d6efd',
                              color: '#fff',
                              fontWeight: 700,
                              width: 'fit-content',
                            }}
                            onClick={() => handleViewLegalLetterDocuments(item.AgreementNo)}
                          >
                            📄 View Documents
                          </button>
                        )}

                        {isLegalTeam && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                              backgroundColor: '#198754',
                              borderColor: '#198754',
                              color: '#fff',
                              fontWeight: 700,
                              width: 'fit-content',
                            }}
                            onClick={() => {
                              setLegalLetterNextStepAgreement(item.AgreementNo);
                              setShowLegalLetterNextStepModal(true);
                            }}
                          >
                            Mark Completed
                          </button>
                        )}
                      </div>
                    )}

                    {status === 'LEGAL_LETTER_COMPLETED' && (
                      <div className="d-flex flex-column gap-1">
                        {isExpanded && (
                          <small className="text-success d-block mb-1">
                            Completed By : {item.updated_by_name || 'Legal Team'}
                          </small>
                        )}

                        {(isChecker || isMaker || isLegalTeam) && (
                          <button
                            className="btn btn-sm"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                              backgroundColor: '#0d6efd',
                              borderColor: '#0d6efd',
                              color: '#fff',
                              fontWeight: 700,
                              width: 'fit-content',
                            }}
                            onClick={() => handleViewLegalLetterDocuments(item.AgreementNo)}
                          >
                            📄 View Documents
                          </button>
                        )}
                      </div>
                    )}

                    {status === 'Court Order Rejected' && !isChecker && (
                      <div className="mt-1">
                        {isExpanded && (
                          <>
                            <span className="text-danger d-block">
                              Court Order Rejected by {item.updated_by_name || 'Credit Operations'}
                            </span>

                            <div
                              style={{
                                marginTop: '6px',
                                maxWidth: '260px',
                              }}
                            >
                              <div
                                style={{
                                  fontSize: '13px',
                                  color: '#6c757d',
                                  lineHeight: '1.5',
                                  wordBreak: 'break-word',
                                  overflow: 'hidden',
                                  display: '-webkit-box',
                                  WebkitLineClamp: expandedNotes[item.AgreementNo] ? 'none' : 2,
                                  WebkitBoxOrient: 'vertical',
                                }}
                              >
                                <strong>Notes:</strong> {item.notes}
                              </div>

                              {item.notes && item.notes.length > 15 && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    setExpandedNotes((prev) => ({
                                      ...prev,
                                      [item.AgreementNo]: !prev[item.AgreementNo],
                                    }))
                                  }
                                  style={{
                                    color: '#0d6efd',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    marginTop: '4px',
                                    display: 'inline-block',
                                    background: 'transparent',
                                    border: 'none',
                                    padding: 0,
                                  }}
                                >
                                  {expandedNotes[item.AgreementNo] ? 'Read Less' : 'Read More'}
                                </button>
                              )}
                            </div>
                          </>
                        )}

                        {uploadingId === item.AgreementNo ? (
                          <div className="mt-2">
                            <input
                              type="file"
                              className="form-control form-control-sm mb-1"
                              accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                              onChange={(e) =>
                                setFiles((prev) => ({
                                  ...prev,
                                  [item.AgreementNo]: e.target.files[0],
                                }))
                              }
                            />

                            <button
                              className="btn btn-sm btn-success me-1"
                              onClick={() => handleUploadCourtOrder(item.AgreementNo)}
                            >
                              Upload
                            </button>

                            <button className="btn btn-sm btn-secondary" onClick={() => setUploadingId(null)}>
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <button
                            className="btn btn-sm btn-warning mt-2"
                            style={{
                              padding: '4px 10px',
                              fontSize: '9px',
                              textTransform: 'capitalize',
                            }}
                            onClick={() => handleReuploadCourtOrder(item.AgreementNo)}
                          >
                            Re-Upload Court Order
                          </button>
                        )}
                      </div>
                    )}
                  </td>
                  <td onClick={(e) => e.stopPropagation()}>
                    <button
                      className="btn btn-sm btn-dark"
                      style={{
                        padding: '4px 10px',
                        fontSize: '9px',
                        textTransform: 'capitalize',
                      }}
                      onClick={() => handleViewActivities(item.AgreementNo)}
                    >
                      👁 View
                    </button>

                    {/* <button
                      className="btn btn-sm btn-info mt-1"
                      style={{
                        padding: '4px 10px',
                        fontSize: '9px',
                        textTransform: 'capitalize',
                      }}
                      onClick={() => handleStaticFlowModal(item)}
                    >
                      View Progress
                    </button> */}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      {/* PAGINATION */}
      {/* PAGINATION */}
      <nav className="d-flex justify-content-end mt-3">
        <ul
          className="pagination align-items-center flex-wrap"
          style={{
            gap: '6px',
            listStyle: 'none',
            margin: 0,
            padding: 0,
          }}
        >
          {/* Back */}
          <li>
            <button
              onClick={() => setPage((p) => Math.max(p - 1, 1))}
              disabled={page === 1}
              style={{
                border: '1px solid #e5e7eb',
                background: '#fff',
                color: page === 1 ? '#c4c9d0' : '#374151',
                borderRadius: '10px',
                padding: '8px 16px',
                fontSize: '13px',
                fontWeight: 600,
                cursor: page === 1 ? 'not-allowed' : 'pointer',
                transition: 'all 0.15s ease',
              }}
              onMouseEnter={(e) => {
                if (page !== 1) e.currentTarget.style.background = '#f3f4f6';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#fff';
              }}
            >
              ‹ Back
            </button>
          </li>

          {/* Page numbers with ellipsis */}
          {getPaginationRange(page, totalPages).map((p, idx) =>
            p === '...' ? (
              <li key={`dots-${idx}`}>
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '38px',
                    height: '38px',
                    color: '#9ca3af',
                    fontSize: '13px',
                    fontWeight: 600,
                  }}
                >
                  •••
                </span>
              </li>
            ) : (
              <li key={p}>
                <button
                  onClick={() => setPage(p)}
                  style={{
                    width: '38px',
                    height: '38px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '10px',
                    border: page === p ? 'none' : '1px solid #e5e7eb',
                    background: page === p ? '#111827' : '#fff',
                    color: page === p ? '#fff' : '#374151',
                    fontSize: '13px',
                    fontWeight: page === p ? 700 : 500,
                    cursor: 'pointer',
                    transition: 'all 0.15s ease',
                    boxShadow: page === p ? '0 2px 6px rgba(17,24,39,0.25)' : 'none',
                  }}
                  onMouseEnter={(e) => {
                    if (page !== p) e.currentTarget.style.background = '#f3f4f6';
                  }}
                  onMouseLeave={(e) => {
                    if (page !== p) e.currentTarget.style.background = '#fff';
                  }}
                >
                  {p}
                </button>
              </li>
            )
          )}

          {/* Next */}
          <li>
            <button
              onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
              disabled={page === totalPages}
              style={{
                border: '1px solid #e5e7eb',
                background: '#fff',
                color: page === totalPages ? '#c4c9d0' : '#374151',
                borderRadius: '10px',
                padding: '8px 16px',
                fontSize: '13px',
                fontWeight: 600,
                cursor: page === totalPages ? 'not-allowed' : 'pointer',
                transition: 'all 0.15s ease',
              }}
              onMouseEnter={(e) => {
                if (page !== totalPages) e.currentTarget.style.background = '#f3f4f6';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = '#fff';
              }}
            >
              Next ›
            </button>
          </li>
        </ul>
      </nav>

      {showReuploadModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',

            background: 'rgba(15, 23, 42, 0.60)',
            backdropFilter: 'blur(3px)',

            zIndex: 999999,

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

            padding: '20px',
          }}
        >
          <div
            className="modal-dialog"
            style={{
              width: '100%',
              maxWidth: '620px',
              margin: 0,
            }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: '18px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 10px 35px rgba(0,0,0,0.18)',
                marginLeft: '70px',
              }}
            >
              {/* HEADER */}
              <div
                className="modal-header"
                style={{
                  padding: '22px 26px',
                  borderBottom: '1px solid #ececec',
                }}
              >
                <div>
                  <h4
                    className="modal-title mb-1"
                    style={{
                      fontWeight: '700',
                      color: '#212529',
                      fontSize: '28px',
                    }}
                  >
                    Re-Upload Court Order
                  </h4>

                  <div
                    style={{
                      fontSize: '14px',
                      color: '#6c757d',
                    }}
                  >
                    Upload updated court order document
                  </div>
                </div>

                <button type="button" className="btn-close" onClick={() => setShowReuploadModal(false)} />
              </div>

              {/* BODY */}
              <div
                className="modal-body"
                style={{
                  padding: '24px 26px',
                }}
              >
                {/* FILE */}
                <div className="mb-4">
                  <label
                    className="form-label"
                    style={{
                      fontWeight: '600',
                      fontSize: '15px',
                      marginBottom: '10px',
                    }}
                  >
                    Upload File
                  </label>

                  <input
                    type="file"
                    className="form-control"
                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                    style={{
                      height: '48px',
                      borderRadius: '10px',
                      padding: '10px 14px',
                      fontSize: '14px',
                    }}
                    onChange={(e) =>
                      setFiles((prev) => ({
                        ...prev,
                        [reuploadAgreement]: e.target.files[0],
                      }))
                    }
                  />

                  <small
                    style={{
                      color: '#6c757d',
                      fontSize: '12px',
                    }}
                  >
                    Supported: JPG, PNG, PDF, DOC, DOCX
                  </small>
                </div>

                {/* NOTES */}
                <div>
                  <label
                    className="form-label"
                    style={{
                      fontWeight: '600',
                      fontSize: '15px',
                      marginBottom: '10px',
                    }}
                  >
                    Notes
                  </label>

                  <textarea
                    className="form-control"
                    rows="5"
                    placeholder="Enter re-upload reason..."
                    value={resendNotes}
                    onChange={(e) => setResendNotes(e.target.value)}
                    style={{
                      borderRadius: '12px',
                      padding: '14px',
                      resize: 'none',
                      fontSize: '14px',
                    }}
                  />
                </div>
              </div>

              {/* FOOTER */}
              <div
                className="modal-footer"
                style={{
                  padding: '18px 26px',
                  borderTop: '1px solid #ececec',
                }}
              >
                <button
                  className="btn btn-light"
                  onClick={() => setShowReuploadModal(false)}
                  style={{
                    padding: '3px 10px',
                    fontSize: '9px',
                    minHeight: '32px',
                    borderRadius: '6px',
                    minWidth: '130px',
                    fontWeight: '600',
                    border: '1px solid #dcdcdc',
                  }}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-warning"
                  onClick={submitReuploadCourtOrder}
                  disabled={postLoading}
                  style={{
                    padding: '3px 10px',
                    fontSize: '9px',
                    minHeight: '32px',
                    borderRadius: '6px',
                    fontWeight: '600',
                    textTransform: 'capitalize',
                    minWidth: '130px',
                    opacity: postLoading ? 0.7 : 1,
                  }}
                >
                  {postLoading ? 'Submitting...' : 'Submit Court Order'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showNotesModal && (
        <div className="modal d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {selectedAction === 'approve' ? 'Approve Court Order' : 'Reject Court Order'}
                </h5>

                <button type="button" className="btn-close" onClick={() => setShowNotesModal(false)} />
              </div>

              <div className="modal-body">
                <label className="form-label fw-bold">Notes</label>

                <textarea
                  className="form-control"
                  rows="4"
                  placeholder="Enter notes..."
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                />
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowNotesModal(false)}>
                  Cancel
                </button>

                {/* --- PRELOADER: Submit button disabled while POST is in-flight --- */}
                <button
                  className={`btn ${selectedAction === 'approve' ? 'btn-success' : 'btn-danger'}`}
                  onClick={submitCourtOrderAction}
                  disabled={postLoading}
                  style={{ opacity: postLoading ? 0.7 : 1 }}
                >
                  {postLoading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* VIEW RE-UPLOAD NOTES MODAL — Checker only */}
      {showViewNotesModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',

            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(3px)',

            zIndex: 999999,

            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',

            padding: '20px',
          }}
        >
          <div
            className="modal-dialog"
            style={{
              width: '100%',
              maxWidth: '620px',
              margin: '0 auto',
              position: 'relative',
              zIndex: 1000000,
            }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: '18px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 10px 35px rgba(0,0,0,0.18)',
              }}
            >
              {/* HEADER */}
              <div
                className="modal-header"
                style={{
                  padding: '22px 26px',
                  borderBottom: '1px solid #ececec',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                  }}
                >
                  <div
                    style={{
                      width: '46px',
                      height: '46px',
                      borderRadius: '12px',
                      background: '#fff3cd',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '22px',
                    }}
                  >
                    📝
                  </div>

                  <div>
                    <h4
                      style={{
                        margin: 0,
                        fontWeight: '700',
                        fontSize: '26px',
                        color: '#212529',
                        lineHeight: '1.2',
                      }}
                    >
                      Re-Upload Notes
                    </h4>

                    <div
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        marginTop: '3px',
                      }}
                    >
                      Notes submitted by maker
                    </div>
                  </div>
                </div>

                <button type="button" className="btn-close" onClick={() => setShowViewNotesModal(false)} />
              </div>

              {/* BODY */}
              <div
                className="modal-body"
                style={{
                  padding: '24px 26px',
                }}
              >
                <div
                  style={{
                    background: '#f8f9fb',
                    border: '1px solid #e9ecef',
                    borderRadius: '14px',
                    padding: '18px 20px',
                    fontSize: '15px',
                    color: '#343a40',
                    lineHeight: '1.8',
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                  }}
                >
                  {viewNotesContent?.trim() ? viewNotesContent : 'No notes provided.'}
                </div>
              </div>

              {/* FOOTER */}
              <div
                className="modal-footer"
                style={{
                  padding: '18px 26px',
                  borderTop: '1px solid #ececec',
                }}
              >
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowViewNotesModal(false)}
                  style={{
                    minWidth: '120px',
                    height: '44px',
                    borderRadius: '10px',
                    fontWeight: '600',
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showActivityModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            background: 'rgba(0,0,0,0.5)',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div
            className="modal-dialog modal-xl modal-dialog-centered"
            style={{
              maxWidth: '1350px',
              width: '92vw',
              margin: 'auto',
            }}
          >
            <div
              className="modal-content"
              style={{
                marginLeft: '181px',
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title">📋 All Repo Activities</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowActivityModal(false);
                    setActivityLogs([]);
                  }}
                />
              </div>

              <div className="modal-body">
                {activityLoading ? (
                  <div className="text-center py-4">Loading activities...</div>
                ) : activityLogs.length === 0 ? (
                  <div className="text-center text-muted py-4">No activity found</div>
                ) : (
                  <div className="table-responsive">
                    <table
                      className="table table-bordered align-middle"
                      style={{
                        tableLayout: 'fixed',
                      }}
                    >
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: '60px' }}>#</th>

                          <th style={{ width: '55%' }}>Activity</th>

                          <th style={{ width: '18%' }}>Created By</th>

                          <th style={{ width: '22%' }}>Date & Time</th>
                        </tr>
                      </thead>

                      <tbody>
                        {activityLogs.map((log, index) => (
                          <tr
                            key={log.id}
                            style={{
                              height: 'auto',
                            }}
                          >
                            <td>{index + 1}</td>

                            <td
                              style={{
                                padding: '10px 14px',
                                lineHeight: '1.35',
                                verticalAlign: 'top',
                              }}
                            >
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: '15px',
                                  marginBottom: '6px',
                                  color: '#212529',
                                }}
                              >
                                {log.log_description}
                              </div>

                              {log.otherDetails &&
                                (() => {
                                  let details = {};

                                  try {
                                    details =
                                      typeof log.otherDetails === 'string'
                                        ? JSON.parse(log.otherDetails)
                                        : log.otherDetails;
                                  } catch {
                                    details = {};
                                  }

                                  // ---- Dynamic file/URL detector ----
                                  const FILE_EXT_REGEX =
                                    /\.(jpe?g|png|gif|webp|bmp|svg|pdf|docx?|xlsx?|csv|zip|rar|txt|pptx?)$/i;

                                  const isFileLike = (val) => {
                                    if (typeof val !== 'string') return false;
                                    const trimmed = val.trim();
                                    if (!trimmed || trimmed === 'null') return false;
                                    return FILE_EXT_REGEX.test(trimmed);
                                  };

                                  const buildFileUrl = (val) => {
                                    if (/^https?:\/\//i.test(val)) return val;
                                    return `${config.API_BASE_URL}${val.replace(/^\//, '')}`;
                                  };

                                  const renderFileLink = (val, key) => (
                                    <a
                                      key={key}
                                      href={buildFileUrl(val)}
                                      target="_blank"
                                      rel="noreferrer"
                                      download
                                      style={{
                                        color: '#0d6efd',
                                        marginRight: '10px',
                                        marginTop: '2px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        textDecoration: 'underline',
                                        display: 'inline-block',
                                      }}
                                    >
                                      ⬇ Download File
                                    </a>
                                  );

                                  return (
                                    <div className="mt-1">
                                      {Object.entries(details).map(([key, value]) => {
                                        if (value === null || value === undefined || value === '' || value === 'null') {
                                          return null;
                                        }

                                        // ARRAY values — e.g. cheque_documents: ["path1","path2"] or documents: [{name, path}]
                                        if (Array.isArray(value)) {
                                          if (value.length === 0) return null;

                                          const hasFiles = value.some((item) => {
                                            if (typeof item === 'string') return isFileLike(item);
                                            if (item && typeof item === 'object') {
                                              return isFileLike(item.path) || isFileLike(item.url);
                                            }
                                            return false;
                                          });

                                          if (!hasFiles) {
                                            return (
                                              <div
                                                key={key}
                                                style={{
                                                  fontSize: '13px',
                                                  color: '#6c757d',
                                                  marginBottom: '2px',
                                                  lineHeight: '1.4',
                                                }}
                                              >
                                                <strong>{key.replaceAll('_', ' ').toUpperCase()}:</strong>{' '}
                                                {value
                                                  .map((v) => (typeof v === 'object' ? JSON.stringify(v) : String(v)))
                                                  .join(', ')}
                                              </div>
                                            );
                                          }

                                          return (
                                            <div
                                              key={key}
                                              style={{ fontSize: '13px', marginBottom: '4px', lineHeight: '1.6' }}
                                            >
                                              <strong>{key.replaceAll('_', ' ').toUpperCase()}:</strong>{' '}
                                              {value.map((item, idx) => {
                                                const path = typeof item === 'string' ? item : item.path || item.url;
                                                if (!isFileLike(path)) return null;
                                                return renderFileLink(path, `${key}_${idx}`);
                                              })}
                                            </div>
                                          );
                                        }

                                        // OBJECT values — e.g. { name, path }
                                        if (value && typeof value === 'object') {
                                          const path = value.path || value.url;

                                          if (isFileLike(path)) {
                                            return (
                                              <div
                                                key={key}
                                                style={{ fontSize: '13px', marginBottom: '3px', lineHeight: '1.4' }}
                                              >
                                                <strong>{key.replaceAll('_', ' ').toUpperCase()}:</strong>
                                                {renderFileLink(path, key)}
                                              </div>
                                            );
                                          }

                                          return (
                                            <div
                                              key={key}
                                              style={{
                                                fontSize: '13px',
                                                color: '#6c757d',
                                                marginBottom: '2px',
                                                lineHeight: '1.4',
                                              }}
                                            >
                                              <strong>{key.replaceAll('_', ' ').toUpperCase()}:</strong>{' '}
                                              {JSON.stringify(value)}
                                            </div>
                                          );
                                        }

                                        // STRING values
                                        if (isFileLike(value)) {
                                          return (
                                            <div
                                              key={key}
                                              style={{ fontSize: '13px', marginBottom: '3px', lineHeight: '1.4' }}
                                            >
                                              <strong>{key.replaceAll('_', ' ').toUpperCase()}:</strong>
                                              {renderFileLink(value, key)}
                                            </div>
                                          );
                                        }

                                        return (
                                          <div
                                            key={key}
                                            style={{
                                              fontSize: '13px',
                                              color: '#6c757d',
                                              marginBottom: '2px',
                                              lineHeight: '1.4',
                                            }}
                                          >
                                            <strong>{key.replaceAll('_', ' ').toUpperCase()}:</strong> {String(value)}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  );
                                })()}
                            </td>

                            <td
                              style={{
                                padding: '10px',
                                fontSize: '14px',
                                verticalAlign: 'middle',
                              }}
                            >
                              {log.created_by_name || 'User'}
                            </td>

                            <td
                              style={{
                                padding: '10px',
                                fontSize: '14px',
                                whiteSpace: 'nowrap',
                                verticalAlign: 'middle',
                              }}
                            >
                              {new Date(log.created_on).toLocaleString('en-IN', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',

                                hour: '2-digit',
                                minute: '2-digit',
                              })}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showFlowModal &&
        selectedFlowItem &&
        (() => {
          const allSteps = [
            'Pending',
            'Approved',
            'Pending for Court Order Review',
            'Court Order Approved',
            'Repo Initiated',
            'Repo Checklist Submitted',
            'Inspection Scheduled',
            'Inventory Created',
            'Yard Placement Pending',
            'Vehicle Yarded',
            'Ready For Listing Approval',
            'Listing Approved',
            'Live For Auction',
            'Auction Completed',
            'Sold',
          ];

          // ===== DYNAMIC STEP MAP =====
          const logStepMap = {
            'Legal action created with status Pending': 'Pending',

            'Legal action Approved': 'Approved',

            'Court order uploaded and sent for review': 'Pending for Court Order Review',

            'Court Order Approved': 'Court Order Approved',

            'Repo process initiated successfully': 'Repo Initiated',

            'Repo checklist submitted successfully': 'Repo Checklist Submitted',

            'Inspection scheduled successfully': 'Inspection Scheduled',

            'Final inventory created successfully': 'Inventory Created',

            'Yard placement updated successfully': 'Yard Placement Pending',

            'Vehicle yarded successfully': 'Vehicle Yarded',

            'Ready for listing approval': 'Ready For Listing Approval',

            'Listing approved successfully': 'Listing Approved',

            'Vehicle live for auction': 'Live For Auction',

            'Auction completed successfully': 'Auction Completed',

            'Vehicle sold successfully': 'Sold',
          };

          // ===== FIND CURRENT STEP FROM ACTIVITY LOGS =====

          let currentStep = 'Pending';

          if (activityLogs?.length > 0) {
            const sortedLogs = [...activityLogs].sort((a, b) => new Date(b.created_on) - new Date(a.created_on));

            sortedLogs.some((log) => {
              const matchedKey = Object.keys(logStepMap).find((key) =>
                log.log_description?.toLowerCase().includes(key.toLowerCase())
              );

              if (matchedKey) {
                currentStep = logStepMap[matchedKey];

                return true;
              }

              return false;
            });
          }

          const currentIndex = allSteps.indexOf(currentStep);
          const activeIndex = currentIndex + 1;

          return (
            <div
              className="modal show fade d-flex align-items-center justify-content-center"
              style={{
                background: 'rgba(0,0,0,0.45)',
                position: 'fixed',
                inset: 0,
                zIndex: 999999,
              }}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                style={{
                  maxWidth: '680px',
                  width: '95%',
                }}
              >
                <div
                  className="modal-content"
                  style={{
                    borderRadius: '22px',
                    overflow: 'hidden',
                    border: 'none',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
                  }}
                >
                  {/* HEADER */}

                  <div
                    className="modal-header"
                    style={{
                      background: 'linear-gradient(135deg,#0f172a,#1e293b)',
                      color: '#fff',
                      padding: '20px 28px',
                      border: 'none',
                    }}
                  >
                    <div>
                      <h4
                        style={{
                          margin: 0,
                          fontWeight: '700',
                        }}
                      >
                        Repo Progress Flow
                      </h4>

                      <div
                        style={{
                          opacity: 0.8,
                          fontSize: '13px',
                          marginTop: '4px',
                        }}
                      >
                        Agreement No : {selectedFlowItem.AgreementNo}
                      </div>
                    </div>

                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      onClick={() => setShowFlowModal(false)}
                    />
                  </div>

                  {/* BODY */}

                  <div
                    className="modal-body"
                    style={{
                      padding: '30px 26px',
                      background: '#f8fafc',
                      maxHeight: '70vh',
                      overflowY: 'auto',
                    }}
                  >
                    {allSteps.map((step, index) => {
                      const completed = index <= currentIndex;

                      const active = index === activeIndex;

                      return (
                        <div
                          key={step}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '28px',
                            position: 'relative',
                          }}
                        >
                          {/* LINE */}

                          {index !== allSteps.length - 1 && (
                            <div
                              style={{
                                position: 'absolute',
                                left: '20px',
                                top: '42px',
                                width: '4px',
                                height: '60px',
                                background: completed ? '#16a34a' : '#d4d4d8',
                                borderRadius: '20px',
                              }}
                            />
                          )}

                          {/* CIRCLE */}

                          <div
                            style={{
                              minWidth: '42px',
                              height: '42px',
                              borderRadius: '50%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: '700',
                              color: '#fff',
                              fontSize: '15px',
                              zIndex: 2,
                              background: completed ? '#16a34a' : active ? '#f59e0b' : '#cbd5e1',
                              animation: active ? 'pulse 1.2s infinite' : 'none',
                              boxShadow: completed
                                ? '0 0 15px rgba(22,163,74,0.35)'
                                : active
                                ? '0 0 18px rgba(245,158,11,0.45)'
                                : 'none',
                            }}
                          >
                            {completed ? '✓' : index + 1}
                          </div>

                          {/* CONTENT */}

                          <div
                            style={{
                              marginLeft: '18px',
                              flex: 1,
                            }}
                          >
                            <div
                              style={{
                                fontSize: '16px',
                                fontWeight: '700',
                                color: completed || active ? '#0f172a' : '#64748b',
                              }}
                            >
                              {step}
                            </div>

                            <div
                              style={{
                                fontSize: '13px',
                                marginTop: '3px',
                                color: '#64748b',
                              }}
                            >
                              {completed ? 'Completed Successfully' : active ? 'Current Active Step' : 'Waiting'}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>

              <style>
                {`
            @keyframes pulse {

              0% {
                transform: scale(1);
                opacity: 1;
              }

              50% {
                transform: scale(1.08);
                opacity: 0.7;
              }

              100% {
                transform: scale(1);
                opacity: 1;
              }

            }
          `}
              </style>
            </div>
          );
        })()}

      {showSurrenderConfirmModal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15,23,42,0.55)',
            backdropFilter: 'blur(4px)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              width: '380px',
              background: '#fff',
              borderRadius: '14px',
              overflow: 'hidden',
              boxShadow: '0 15px 40px rgba(0,0,0,0.15)',
            }}
          >
            {/* Header */}
            <div
              style={{
                padding: '22px 20px 10px',
                textAlign: 'center',
                position: 'relative',
              }}
            >
              <button
                type="button"
                onClick={() => {
                  setShowSurrenderConfirmModal(false);
                  setSelectedSurrenderAgreement('');
                  setSurrenderNote('');
                }}
                style={{
                  position: 'absolute',
                  right: '14px',
                  top: '10px',
                  border: 'none',
                  background: 'transparent',
                  fontSize: '24px',
                  color: '#999',
                  cursor: 'pointer',
                }}
              >
                ×
              </button>

              <h4
                style={{
                  margin: 0,
                  fontWeight: '700',
                  color: '#1f2937',
                  fontSize: '28px',
                }}
              >
                Surrender
              </h4>
            </div>

            {/* Body */}
            <div
              style={{
                padding: '10px 25px 20px',
                textAlign: 'center',
              }}
            >
              <p
                style={{
                  margin: '0 0 15px 0',
                  fontSize: '15px',
                  color: '#6b7280',
                }}
              >
                Mention the reason for surrender
              </p>

              <textarea
                className="form-control"
                rows="3"
                placeholder="Enter note..."
                value={surrenderNote}
                onChange={(e) => setSurrenderNote(e.target.value)}
                style={{
                  resize: 'none',
                  borderRadius: '8px',
                  fontSize: '13px',
                }}
              />
            </div>

            {/* Footer */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '10px',
                padding: '0 20px 20px',
              }}
            >
              <button
                onClick={() => {
                  setShowSurrenderConfirmModal(false);
                  setSelectedSurrenderAgreement('');
                  setSurrenderNote('');
                }}
                style={{
                  width: '85px',
                  height: '36px',
                  border: '1px solid #d1d5db',
                  background: '#fff',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '13px',
                  cursor: 'pointer',
                }}
              >
                No
              </button>

              <button
                onClick={submitVehicleSurrender}
                disabled={postLoading}
                style={{
                  width: '85px',
                  height: '36px',
                  border: 'none',
                  background: '#C41E3A',
                  color: '#fff',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '13px',
                  cursor: postLoading ? 'not-allowed' : 'pointer',
                  opacity: postLoading ? 0.7 : 1,
                }}
              >
                {postLoading ? 'Submitting...' : 'Yes'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showLegalOptionsModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ width: '100%', maxWidth: '560px', margin: 0 }}>
            <div
              className="modal-content"
              style={{
                width: '550px',
                borderRadius: '18px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 15px 45px rgba(0,0,0,0.22)',
              }}
            >
              {/* HEADER */}
              <div className="modal-header" style={{ padding: '20px 26px', borderBottom: '1px solid #ececec' }}>
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700, color: '#212529', fontSize: '20px' }}>
                    Select Legal Action
                  </h5>
                  <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '4px' }}>
                    Agreement No : <strong style={{ color: '#495057' }}>{legalOptionsAgreement}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowLegalOptionsModal(false);
                    setLegalOptionsAgreement('');
                  }}
                />
              </div>

              {/* BODY */}
              <div
                className="modal-body"
                style={{
                  padding: '24px 26px 26px',
                  display: 'flex',
                  gap: '12px',
                }}
              >
                {/* Section 9 - actual working flow */}
                <button
                  className="btn btn-sm"
                  style={{
                    flex: 1,
                    padding: '9px 8px',
                    fontSize: '12px',
                    fontWeight: 700,
                    borderRadius: '8px',
                    backgroundColor: '#ffc107',
                    borderColor: '#ffc107',
                    color: '#212529',
                    textTransform: 'uppercase',
                    letterSpacing: '0.3px',
                  }}
                  onClick={() => {
                    console.log('LEGAL OPTIONS DPD:', legalOptionsDpd);
                    setSection9Agreement(legalOptionsAgreement);
                    setSection9Dpd(legalOptionsDpd);
                    setShowLegalOptionsModal(false);
                    setLegalOptionsAgreement('');
                    setShowSection9Modal(true);
                  }}
                >
                  Section 9
                </button>

                {/* Legal Letter */}
                <button
                  className="btn btn-sm"
                  style={{
                    flex: 1,
                    padding: '9px 8px',
                    fontSize: '12px',
                    fontWeight: 700,
                    borderRadius: '8px',
                    backgroundColor: '#0dcaf0',
                    borderColor: '#0dcaf0',
                    color: '#fff',
                    textTransform: 'uppercase',
                    letterSpacing: '0.3px',
                  }}
                  onClick={() => {
                    setLegalLetterAgreement(legalOptionsAgreement);
                    setShowLegalOptionsModal(false);
                    setLegalOptionsAgreement('');
                    setShowLegalLetterModal(true);
                  }}
                >
                  Legal Letter
                </button>

                {/* Section 138 */}
                {/* Section 138 */}
                <button
                  className="btn btn-sm"
                  style={{
                    flex: 1,
                    padding: '9px 8px',
                    fontSize: '12px',
                    fontWeight: 700,
                    borderRadius: '8px',
                    backgroundColor: '#6f42c1',
                    borderColor: '#6f42c1',
                    color: '#fff',
                    textTransform: 'uppercase',
                    letterSpacing: '0.3px',
                  }}
                  onClick={() => {
                    setSection138Agreement(legalOptionsAgreement);
                    setShowLegalOptionsModal(false);
                    setLegalOptionsAgreement('');
                    setShowSection138Modal(true);
                  }}
                >
                  Section 138
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* // NEW — classy grid layout */}
      {showSection9Modal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ width: '100%', maxWidth: '760px', margin: 0 }}>
            <div
              className="modal-content"
              style={{
                borderRadius: '20px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
                width: '100%',
              }}
            >
              {/* HEADER */}
              <div
                className="modal-header"
                style={{
                  padding: '22px 30px',
                  borderBottom: '1px solid #eef0f2',
                  background: 'linear-gradient(135deg,#fffbea,#fff)',
                }}
              >
                <div>
                  <h5 style={{ margin: 0, fontWeight: 800, color: '#1f2937', fontSize: '20px' }}>
                    Section 9 — Legal Action Details
                  </h5>
                  <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '5px' }}>
                    Agreement No : <strong style={{ color: '#111827' }}>{section9Agreement}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  disabled={section9Loading}
                  onClick={() => {
                    setShowSection9Modal(false);
                    setSection9Agreement('');
                  }}
                />
              </div>

              {/* BODY */}
              <div
                className="modal-body"
                style={{
                  padding: '28px 30px',
                  maxHeight: '68vh',
                  overflowY: 'auto',
                }}
              >
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '18px 20px',
                  }}
                >
                  {[
                    { key: 'customer_name', label: 'Customer Name' },
                    { key: 'vehicle_name', label: 'Vehicle Name' },
                    { key: 'receiver_name', label: 'Receiver Name' },
                    { key: 'loan_number', label: 'Loan Number' },
                  ].map((field) => (
                    <div key={field.key}>
                      <label
                        className="form-label"
                        style={{ fontWeight: 600, fontSize: '12.5px', color: '#374151', marginBottom: '7px' }}
                      >
                        {field.label}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Enter ${field.label}`}
                        value={section9Data[field.key]}
                        disabled={section9Loading}
                        onChange={(e) => setSection9Data((prev) => ({ ...prev, [field.key]: e.target.value }))}
                        style={{
                          borderRadius: '10px',
                          padding: '11px 14px',
                          fontSize: '13.5px',
                          border: '1px solid #e0e0e0',
                          background: '#fafbfc',
                        }}
                      />
                    </div>
                  ))}

                  {/* Full width field */}
                  <div style={{ gridColumn: '1 / -1' }}>
                    <label
                      className="form-label"
                      style={{ fontWeight: 600, fontSize: '12.5px', color: '#374151', marginBottom: '7px' }}
                    >
                      Police Station Address
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Police Station Address"
                      value={section9Data.police_station_address}
                      disabled={section9Loading}
                      onChange={(e) => setSection9Data((prev) => ({ ...prev, police_station_address: e.target.value }))}
                      style={{
                        borderRadius: '10px',
                        padding: '11px 14px',
                        fontSize: '13.5px',
                        border: '1px solid #e0e0e0',
                        background: '#fafbfc',
                      }}
                    />
                  </div>
                </div>

                {/* MULTIPLE FILE UPLOADER */}
                <div style={{ marginTop: '22px' }}>
                  <label
                    className="form-label"
                    style={{ fontWeight: 600, fontSize: '12.5px', color: '#374151', marginBottom: '7px' }}
                  >
                    Upload Supporting Documents
                  </label>

                  <label
                    htmlFor="section9FileInput"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      border: '1.5px dashed #d1d5db',
                      borderRadius: '12px',
                      padding: '18px',
                      background: '#fafbfc',
                      cursor: section9Loading ? 'not-allowed' : 'pointer',
                      color: '#6b7280',
                      fontSize: '13px',
                      fontWeight: 600,
                    }}
                  >
                    📎 Click to upload files (JPG, PNG, PDF, DOC, DOCX)
                  </label>
                  <input
                    id="section9FileInput"
                    type="file"
                    multiple
                    hidden
                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                    disabled={section9Loading}
                    onChange={(e) => setSection9Files(Array.from(e.target.files))}
                  />

                  {section9Files.length > 0 && (
                    <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {section9Files.map((f, i) => (
                        <div
                          key={i}
                          style={{
                            fontSize: '12px',
                            color: '#374151',
                            background: '#f3f4f6',
                            border: '1px solid #e5e7eb',
                            borderRadius: '20px',
                            padding: '6px 12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            maxWidth: '220px',
                          }}
                        >
                          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            📄 {f.name}
                          </span>
                          <button
                            type="button"
                            disabled={section9Loading}
                            onClick={() => setSection9Files((prev) => prev.filter((_, idx) => idx !== i))}
                            style={{
                              border: 'none',
                              background: 'transparent',
                              color: '#dc3545',
                              fontSize: '14px',
                              cursor: 'pointer',
                              lineHeight: 1,
                              fontWeight: 700,
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* FOOTER */}
              <div
                className="modal-footer"
                style={{ padding: '16px 30px', borderTop: '1px solid #eef0f2', background: '#fafbfc' }}
              >
                <button
                  className="btn btn-light"
                  disabled={section9Loading}
                  onClick={() => {
                    setShowSection9Modal(false);
                    setSection9Agreement('');
                  }}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 600,
                    border: '1px solid #dcdcdc',
                  }}
                >
                  Cancel
                </button>

                <button
                  className="btn"
                  onClick={handleSubmitSection9}
                  disabled={section9Loading}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 700,
                    backgroundColor: '#ffc107',
                    borderColor: '#ffc107',
                    color: '#212529',
                    minWidth: '120px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    opacity: section9Loading ? 0.8 : 1,
                    boxShadow: '0 4px 10px rgba(255,193,7,0.35)',
                  }}
                >
                  {section9Loading ? (
                    <>
                      <span
                        style={{
                          width: '13px',
                          height: '13px',
                          border: '2px solid rgba(33,37,41,0.3)',
                          borderTop: '2px solid #212529',
                          borderRadius: '50%',
                          display: 'inline-block',
                          animation: 'spin9 0.7s linear infinite',
                        }}
                      />
                      Submitting...
                    </>
                  ) : (
                    'Submit'
                  )}
                </button>
              </div>
              <style>{`@keyframes spin9 { to { transform: rotate(360deg); } }`}</style>
            </div>
          </div>
        </div>
      )}
      {showForwardToLegalModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ width: '100%', maxWidth: '900px', margin: 0 }}>
            <div
              className="modal-content"
              style={{
                borderRadius: '20px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
                width: '100%',
              }}
            >
              {/* HEADER */}
              <div
                className="modal-header"
                style={{
                  padding: '22px 30px',
                  borderBottom: '1px solid #eef0f2',
                  background: 'linear-gradient(135deg,#eef6ff,#fff)',
                }}
              >
                <div>
                  <h5 style={{ margin: 0, fontWeight: 800, color: '#1f2937', fontSize: '20px' }}>
                    Forward Section 9 Case to Legal Team
                  </h5>
                  <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '5px' }}>
                    Agreement No : <strong style={{ color: '#111827' }}>{forwardToLegalAgreement}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  disabled={forwardToLegalLoading}
                  onClick={() => {
                    setShowForwardToLegalModal(false);
                    setForwardToLegalAgreement('');
                    setForwardToLegalFiles({ soa: null, legal_closure_document: null, loan_agreement: null });
                  }}
                />
              </div>

              {/* BODY */}
              {/* BODY */}
              <div
                className="modal-body"
                style={{
                  padding: '28px 30px',
                  maxHeight: '68vh',
                  overflowY: 'auto',
                }}
              >
                <p style={{ fontSize: '13.5px', color: '#6b7280', marginBottom: '22px' }}>
                  Please upload the following documents to verify and forward this case to the Legal Team.
                </p>

                {[
                  { key: 'soa', label: 'Statement of Account (SOA)' },
                  { key: 'legal_closure_document', label: 'Legal Closure Document' },
                  { key: 'loan_agreement', label: 'Loan Agreement (Soft Copy)' },
                ].map((doc) => (
                  <div key={doc.key} style={{ marginBottom: '18px' }}>
                    <label
                      className="form-label"
                      style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                    >
                      {doc.label}
                    </label>

                    <label
                      htmlFor={`forward-legal-${doc.key}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '8px',
                        border: '1.5px dashed #d1d5db',
                        borderRadius: '12px',
                        padding: '14px 18px',
                        background: '#fafbfc',
                        cursor: forwardToLegalLoading ? 'not-allowed' : 'pointer',
                        color: '#6b7280',
                        fontSize: '13px',
                        fontWeight: 600,
                      }}
                    >
                      <span>
                        📎{' '}
                        {forwardToLegalFiles[doc.key]
                          ? forwardToLegalFiles[doc.key].name
                          : `Click to upload ${doc.label}`}
                      </span>

                      {forwardToLegalFiles[doc.key] && (
                        <span style={{ color: '#16a34a', fontSize: '12px', fontWeight: 700 }}>✓ Uploaded</span>
                      )}
                    </label>

                    <input
                      id={`forward-legal-${doc.key}`}
                      type="file"
                      hidden
                      accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                      disabled={forwardToLegalLoading}
                      onChange={(e) =>
                        setForwardToLegalFiles((prev) => ({
                          ...prev,
                          [doc.key]: e.target.files[0],
                        }))
                      }
                    />
                  </div>
                ))}

                {/* NOTE FIELD */}
                <div style={{ marginTop: '10px' }}>
                  <label
                    className="form-label"
                    style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                  >
                    Note
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Enter note for legal team..."
                    value={forwardToLegalNote}
                    disabled={forwardToLegalLoading}
                    onChange={(e) => setForwardToLegalNote(e.target.value)}
                    style={{
                      borderRadius: '10px',
                      padding: '12px 14px',
                      fontSize: '13.5px',
                      border: '1px solid #e0e0e0',
                      background: '#fafbfc',
                      resize: 'none',
                    }}
                  />
                </div>
              </div>

              {/* FOOTER */}
              <div
                className="modal-footer"
                style={{ padding: '16px 30px', borderTop: '1px solid #eef0f2', background: '#fafbfc' }}
              >
                <button
                  className="btn btn-light"
                  disabled={forwardToLegalLoading}
                  onClick={() => {
                    setShowForwardToLegalModal(false);
                    setForwardToLegalAgreement('');
                    setForwardToLegalFiles({ soa: null, legal_closure_document: null, loan_agreement: null });
                  }}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 600,
                    border: '1px solid #dcdcdc',
                  }}
                >
                  Cancel
                </button>

                <button
                  className="btn"
                  onClick={handleSubmitForwardToLegal}
                  disabled={forwardToLegalLoading}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 700,
                    backgroundColor: '#ffc107',
                    borderColor: '#ffc107',
                    color: '#212529',
                    minWidth: '160px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    opacity: forwardToLegalLoading ? 0.8 : 1,
                    boxShadow: '0 4px 10px rgba(255,193,7,0.35)',
                  }}
                >
                  {forwardToLegalLoading ? (
                    <>
                      <span
                        style={{
                          width: '13px',
                          height: '13px',
                          border: '2px solid rgba(33,37,41,0.3)',
                          borderTop: '2px solid #212529',
                          borderRadius: '50%',
                          display: 'inline-block',
                          animation: 'spinFwd 0.7s linear infinite',
                        }}
                      />
                      Submitting...
                    </>
                  ) : (
                    'Submit & Forward'
                  )}
                </button>
              </div>
              <style>{`@keyframes spinFwd { to { transform: rotate(360deg); } }`}</style>
            </div>
          </div>
        </div>
      )}

      {showMakerDetailsModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15,23,42,.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{
              maxWidth: '800px',
              width: '100%',
            }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: '18px',
                overflow: 'hidden',
              }}
            >
              <div className="modal-header">
                <div>
                  <h5 className="mb-0">Section 9 — Maker Submitted Details</h5>

                  {makerDetailsData?.agreement_no && (
                    <small>
                      Agreement No :<b>{makerDetailsData.agreement_no}</b>
                    </small>
                  )}
                </div>

                <button
                  className="btn-close"
                  onClick={() => {
                    setShowMakerDetailsModal(false);
                    setMakerDetailsData(null);
                  }}
                />
              </div>

              <div
                className="modal-body"
                style={{
                  maxHeight: '70vh',
                  overflowY: 'auto',
                }}
              >
                {makerDetailsLoading ? (
                  <div className="text-center">Loading...</div>
                ) : makerDetailsData ? (
                  <>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <strong>Customer Name</strong>
                        <div>{makerDetailsData.customer_name || '-'}</div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <strong>Vehicle Name</strong>
                        <div>{makerDetailsData.vehicle_name || '-'}</div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <strong>Receiver Name</strong>
                        <div>{makerDetailsData.receiver_name || '-'}</div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <strong>Loan Number</strong>
                        <div>{makerDetailsData.loan_number || '-'}</div>
                      </div>

                      <div className="col-md-12 mb-3">
                        <strong>Police Station Address</strong>
                        <div>{makerDetailsData.police_station_address || '-'}</div>
                      </div>
                    </div>

                    <hr />

                    <h6>Supporting Documents</h6>

                    {makerDetailsData.documents?.length ? (
                      <div className="d-flex flex-wrap gap-2">
                        {makerDetailsData.documents.map((doc, i) => (
                          <a
                            key={i}
                            href={`${config.API_BASE_URL}${doc.path}`}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-outline-primary btn-sm"
                          >
                            📄 {doc.name}
                          </a>
                        ))}
                      </div>
                    ) : (
                      <div className="text-muted">No documents uploaded</div>
                    )}
                  </>
                ) : (
                  <div className="text-center text-muted">No details found</div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowMakerDetailsModal(false);
                    setMakerDetailsData(null);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showLegalForwardDetailsModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15,23,42,.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
          }}
        >
          <div
            className="modal-dialog"
            style={{
              maxWidth: '820px',
              width: '100%',
            }}
          >
            <div
              className="modal-content"
              style={{
                borderRadius: '18px',
                overflow: 'hidden',
                border: 'none',
                background: '#fff',
                boxShadow: '0 18px 45px rgba(0,0,0,.18)',
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: '18px 24px',
                  borderBottom: '1px solid #eef2f7',
                  background: 'linear-gradient(135deg,#f8fbff,#ffffff)',
                }}
              >
                <div>
                  <h4
                    style={{
                      margin: 0,
                      fontWeight: 700,
                      color: '#1f2937',
                      fontSize: '22px',
                    }}
                  >
                    Forwarded Legal Details
                  </h4>

                  <small
                    style={{
                      color: '#6b7280',
                      fontSize: '12px',
                    }}
                  >
                    Section 9 Legal Documents
                  </small>
                </div>

                <button
                  className="btn-close"
                  onClick={() => {
                    setShowLegalForwardDetailsModal(false);
                    setLegalForwardData(null);
                  }}
                />
              </div>

              <div
                className="modal-body"
                style={{
                  padding: '20px 24px',
                }}
              >
                {legalForwardLoading ? (
                  <div className="text-center py-4">Loading...</div>
                ) : legalForwardData ? (
                  <>
                    <div
                      style={{
                        marginBottom: '16px',
                      }}
                    >
                      <label
                        style={{
                          fontWeight: 700,
                          color: '#111827',
                          fontSize: '13px',
                          marginBottom: '6px',
                          display: 'block',
                        }}
                      >
                        Notes
                      </label>

                      <div
                        style={{
                          background: '#f8fafc',
                          border: '1px solid #e5e7eb',
                          borderRadius: '10px',
                          padding: '10px 14px',
                          color: '#374151',
                          fontSize: '13px',
                          lineHeight: '1.5',
                        }}
                      >
                        {legalForwardData.notes || '-'}
                      </div>
                    </div>

                    <div
                      style={{
                        borderTop: '1px solid #eef2f7',
                        paddingTop: '16px',
                      }}
                    >
                      <label
                        style={{
                          fontWeight: 700,
                          color: '#111827',
                          fontSize: '13px',
                          marginBottom: '10px',
                          display: 'block',
                        }}
                      >
                        Supporting Documents
                      </label>

                      <div
                        style={{
                          display: 'flex',
                          gap: '10px',
                          flexWrap: 'wrap',
                        }}
                      >
                        <a
                          href={`${config.API_BASE_URL}${legalForwardData.soa_document}`}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '9px 14px',
                            borderRadius: '8px',
                            border: '1px solid #dbeafe',
                            background: '#eff6ff',
                            color: '#2563eb',
                            textDecoration: 'none',
                            fontWeight: 600,
                            fontSize: '12px',
                          }}
                        >
                          📄 SOA
                        </a>

                        <a
                          href={`${config.API_BASE_URL}${legalForwardData.legal_closure_document}`}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '9px 14px',
                            borderRadius: '8px',
                            border: '1px solid #dbeafe',
                            background: '#eff6ff',
                            color: '#2563eb',
                            textDecoration: 'none',
                            fontWeight: 600,
                            fontSize: '12px',
                          }}
                        >
                          📄 Legal Closure
                        </a>

                        <a
                          href={`${config.API_BASE_URL}${legalForwardData.loan_agreement_document}`}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '9px 14px',
                            borderRadius: '8px',
                            border: '1px solid #dbeafe',
                            background: '#eff6ff',
                            color: '#2563eb',
                            textDecoration: 'none',
                            fontWeight: 600,
                            fontSize: '12px',
                          }}
                        >
                          📄 Agreement
                        </a>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="text-center text-muted py-4">No Data Found</div>
                )}
              </div>

              <div
                className="modal-footer"
                style={{
                  padding: '14px 24px',
                  borderTop: '1px solid #eef2f7',
                  background: '#fafbfc',
                }}
              >
                <button
                  className="btn btn-secondary"
                  style={{
                    minWidth: '110px',
                    height: '38px',
                    borderRadius: '8px',
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    setShowLegalForwardDetailsModal(false);
                    setLegalForwardData(null);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showLnrSection9Modal && lnrSection9Item && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15,23,42,0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '640px', width: '100%' }}>
            <div className="modal-content" style={{ borderRadius: '18px', overflow: 'hidden', border: 'none' }}>
              <div className="modal-header" style={{ padding: '20px 26px', borderBottom: '1px solid #ececec' }}>
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700 }}>LNR & Section 9 Documents</h5>
                  <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '4px' }}>
                    Agreement No : <strong>{lnrSection9Item.AgreementNo}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  disabled={lnrSection9Loading}
                  onClick={() => {
                    setShowLnrSection9Modal(false);
                    setLnrSection9Item(null);
                    setLnrFile(null);
                    setSection9FinalFile(null);
                  }}
                />
              </div>

              <div className="modal-body" style={{ padding: '24px 26px' }}>
                {/* LNR SECTION */}
                <div className="mb-4">
                  <label className="form-label" style={{ fontWeight: 600, fontSize: '13px', marginBottom: '8px' }}>
                    LNR Notice
                  </label>

                  {lnrSection9Item.lnr_document ? (
                    <div
                      style={{
                        background: '#f0fdf4',
                        border: '1px solid #bbf7d0',
                        borderRadius: '12px',
                        padding: '14px 18px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <div>
                        <div style={{ fontWeight: 700, color: '#166534', fontSize: '13.5px' }}>
                          ✓ LNR Document Uploaded
                        </div>
                        <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '3px' }}>
                          Uploaded by {lnrSection9Item.lnr_uploaded_by_name || 'Legal Team'}
                        </div>
                      </div>
                      <a
                        href={`${config.API_BASE_URL}${lnrSection9Item.lnr_document}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-success"
                        style={{ fontWeight: 700, fontSize: '12px' }}
                      >
                        👁 View
                      </a>
                    </div>
                  ) : (
                    <input
                      type="file"
                      className="form-control form-control-sm"
                      accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                      disabled={lnrSection9Loading}
                      onChange={(e) => setLnrFile(e.target.files[0])}
                    />
                  )}
                </div>

                {/* SECTION 9 SECTION */}
                <div>
                  <label className="form-label" style={{ fontWeight: 600, fontSize: '13px', marginBottom: '8px' }}>
                    Section 9 Document
                  </label>

                  {lnrSection9Item.section9_final_document ? (
                    <div
                      style={{
                        background: '#eff6ff',
                        border: '1px solid #bfdbfe',
                        borderRadius: '12px',
                        padding: '14px 18px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <div>
                        <div style={{ fontWeight: 700, color: '#1e40af', fontSize: '13.5px' }}>
                          ✓ Section 9 Document Uploaded
                        </div>
                        <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '3px' }}>
                          Uploaded by {lnrSection9Item.section9_uploaded_by_name || 'Legal Team'}
                        </div>
                      </div>
                      <a
                        href={`${config.API_BASE_URL}${lnrSection9Item.section9_final_document}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-primary"
                        style={{ fontWeight: 700, fontSize: '12px' }}
                      >
                        👁 View
                      </a>
                    </div>
                  ) : (
                    <input
                      type="file"
                      className="form-control form-control-sm"
                      accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                      disabled={lnrSection9Loading}
                      onChange={(e) => setSection9FinalFile(e.target.files[0])}
                    />
                  )}
                </div>
              </div>

              <div className="modal-footer" style={{ padding: '16px 26px', borderTop: '1px solid #ececec' }}>
                <button
                  className="btn btn-light"
                  disabled={lnrSection9Loading}
                  onClick={() => {
                    setShowLnrSection9Modal(false);
                    setLnrSection9Item(null);
                    setLnrFile(null);
                    setSection9FinalFile(null);
                  }}
                >
                  Close
                </button>

                {/* Submit button sirf tab dikhega jab kam se kam ek naya file select ho */}
                {(!lnrSection9Item.lnr_document || !lnrSection9Item.section9_final_document) && (
                  <button
                    className="btn"
                    style={{
                      backgroundColor: '#ffc107',
                      borderColor: '#ffc107',
                      color: '#212529',
                      fontWeight: 700,
                      minWidth: '130px',
                    }}
                    onClick={submitLnrSection9Documents}
                    disabled={lnrSection9Loading || (!lnrFile && !section9FinalFile)}
                  >
                    {lnrSection9Loading ? 'Submitting...' : 'Submit'}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {showSection138Modal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ width: '100%', maxWidth: '600px', margin: 0 }}>
            <div
              className="modal-content"
              style={{
                borderRadius: '18px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 15px 45px rgba(0,0,0,0.22)',
              }}
            >
              {/* HEADER */}
              <div
                className="modal-header"
                style={{
                  padding: '20px 26px',
                  borderBottom: '1px solid #ececec',
                  background: 'linear-gradient(135deg,#f4eeff,#fff)',
                }}
              >
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700, color: '#212529', fontSize: '20px' }}>
                    Section 138 — Legal Action
                  </h5>
                  <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '4px' }}>
                    Agreement No : <strong style={{ color: '#111827' }}>{section138Agreement}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  disabled={section138Loading}
                  onClick={() => {
                    setShowSection138Modal(false);
                    setSection138Agreement('');
                    setSection138Note('');
                  }}
                />
              </div>

              {/* BODY */}
              <div className="modal-body" style={{ padding: '24px 26px' }}>
                <label
                  className="form-label"
                  style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                >
                  Note
                </label>

                <textarea
                  className="form-control"
                  rows="5"
                  placeholder="Enter note for Section 138 legal action..."
                  value={section138Note}
                  disabled={section138Loading}
                  onChange={(e) => setSection138Note(e.target.value)}
                  style={{
                    borderRadius: '10px',
                    padding: '12px 14px',
                    fontSize: '13.5px',
                    border: '1px solid #e0e0e0',
                    background: '#fafbfc',
                    resize: 'none',
                  }}
                />
              </div>

              {/* FOOTER */}
              <div
                className="modal-footer"
                style={{ padding: '16px 26px', borderTop: '1px solid #eef0f2', background: '#fafbfc' }}
              >
                <button
                  className="btn btn-light"
                  disabled={section138Loading}
                  onClick={() => {
                    setShowSection138Modal(false);
                    setSection138Agreement('');
                    setSection138Note('');
                  }}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 600,
                    border: '1px solid #dcdcdc',
                  }}
                >
                  Cancel
                </button>

                <button
                  className="btn"
                  onClick={handleSubmitSection138}
                  disabled={section138Loading}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 700,
                    backgroundColor: '#6f42c1',
                    borderColor: '#6f42c1',
                    color: '#fff',
                    minWidth: '120px',
                  }}
                >
                  {section138Loading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showRequestLegalSection138Modal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ width: '100%', maxWidth: '760px', margin: 0 }}>
            <div
              className="modal-content"
              style={{
                borderRadius: '20px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
                width: '100%',
              }}
            >
              {/* HEADER */}
              <div
                className="modal-header"
                style={{
                  padding: '22px 30px',
                  borderBottom: '1px solid #eef0f2',
                  background: 'linear-gradient(135deg,#f4eeff,#fff)',
                }}
              >
                <div>
                  <h5 style={{ margin: 0, fontWeight: 800, color: '#1f2937', fontSize: '20px' }}>
                    Request Section 138 Case to Legal Team
                  </h5>
                  <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '5px' }}>
                    Agreement No : <strong style={{ color: '#111827' }}>{requestLegalSection138Agreement}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  disabled={requestLegalSection138Loading}
                  onClick={() => {
                    setShowRequestLegalSection138Modal(false);
                    setRequestLegalSection138Agreement('');
                    setRequestLegalSection138Files({
                      cheques: [],
                      loan_agreement: null,
                      customer_details: null,
                      foreclosure: null,
                      soa: null,
                    });
                  }}
                />
              </div>

              {/* BODY */}
              <div
                className="modal-body"
                style={{
                  padding: '28px 30px',
                  maxHeight: '68vh',
                  overflowY: 'auto',
                }}
              >
                <p style={{ fontSize: '13.5px', color: '#6b7280', marginBottom: '22px' }}>
                  Please upload the following documents to request this case to the Legal Team.
                </p>

                {/* CHEQUE(S) - MULTIPLE UPLOAD */}
                <div style={{ marginBottom: '18px' }}>
                  <label
                    className="form-label"
                    style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                  >
                    Cheque(s)
                  </label>

                  <label
                    htmlFor="section138ChequeInput"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      border: '1.5px dashed #d1d5db',
                      borderRadius: '12px',
                      padding: '14px 18px',
                      background: '#fafbfc',
                      cursor: requestLegalSection138Loading ? 'not-allowed' : 'pointer',
                      color: '#6b7280',
                      fontSize: '13px',
                      fontWeight: 600,
                    }}
                  >
                    📎 Click to upload Cheque(s) (JPG, PNG, PDF, DOC, DOCX)
                  </label>
                  <input
                    id="section138ChequeInput"
                    type="file"
                    multiple
                    hidden
                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                    disabled={requestLegalSection138Loading}
                    onChange={(e) =>
                      setRequestLegalSection138Files((prev) => ({
                        ...prev,
                        cheques: Array.from(e.target.files),
                      }))
                    }
                  />

                  {requestLegalSection138Files.cheques.length > 0 && (
                    <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {requestLegalSection138Files.cheques.map((f, i) => (
                        <div
                          key={i}
                          style={{
                            fontSize: '12px',
                            color: '#374151',
                            background: '#f3f4f6',
                            border: '1px solid #e5e7eb',
                            borderRadius: '20px',
                            padding: '6px 12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            maxWidth: '220px',
                          }}
                        >
                          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            📄 {f.name}
                          </span>
                          <button
                            type="button"
                            disabled={requestLegalSection138Loading}
                            onClick={() =>
                              setRequestLegalSection138Files((prev) => ({
                                ...prev,
                                cheques: prev.cheques.filter((_, idx) => idx !== i),
                              }))
                            }
                            style={{
                              border: 'none',
                              background: 'transparent',
                              color: '#dc3545',
                              fontSize: '14px',
                              cursor: 'pointer',
                              lineHeight: 1,
                              fontWeight: 700,
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* SINGLE FILE UPLOADS */}
                {[
                  { key: 'loan_agreement', label: 'Loan Agreement' },
                  { key: 'customer_details', label: 'Customer Details' },
                  { key: 'foreclosure', label: 'Foreclosure' },
                  { key: 'soa', label: 'Statement of Account (SOA)' },
                ].map((doc) => (
                  <div key={doc.key} style={{ marginBottom: '18px' }}>
                    <label
                      className="form-label"
                      style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                    >
                      {doc.label}
                    </label>

                    <label
                      htmlFor={`section138-${doc.key}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '8px',
                        border: '1.5px dashed #d1d5db',
                        borderRadius: '12px',
                        padding: '14px 18px',
                        background: '#fafbfc',
                        cursor: requestLegalSection138Loading ? 'not-allowed' : 'pointer',
                        color: '#6b7280',
                        fontSize: '13px',
                        fontWeight: 600,
                      }}
                    >
                      <span>
                        📎{' '}
                        {requestLegalSection138Files[doc.key]
                          ? requestLegalSection138Files[doc.key].name
                          : `Click to upload ${doc.label}`}
                      </span>

                      {requestLegalSection138Files[doc.key] && (
                        <span style={{ color: '#16a34a', fontSize: '12px', fontWeight: 700 }}>✓ Uploaded</span>
                      )}
                    </label>

                    <input
                      id={`section138-${doc.key}`}
                      type="file"
                      hidden
                      accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                      disabled={requestLegalSection138Loading}
                      onChange={(e) =>
                        setRequestLegalSection138Files((prev) => ({
                          ...prev,
                          [doc.key]: e.target.files[0],
                        }))
                      }
                    />
                  </div>
                ))}
              </div>

              {/* FOOTER */}
              <div
                className="modal-footer"
                style={{ padding: '16px 30px', borderTop: '1px solid #eef0f2', background: '#fafbfc' }}
              >
                <button
                  className="btn btn-light"
                  disabled={requestLegalSection138Loading}
                  onClick={() => {
                    setShowRequestLegalSection138Modal(false);
                    setRequestLegalSection138Agreement('');
                    setRequestLegalSection138Files({
                      cheques: [],
                      loan_agreement: null,
                      customer_details: null,
                      foreclosure: null,
                      soa: null,
                    });
                  }}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 600,
                    border: '1px solid #dcdcdc',
                  }}
                >
                  Cancel
                </button>

                <button
                  className="btn"
                  onClick={handleSubmitRequestLegalSection138}
                  disabled={requestLegalSection138Loading}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 700,
                    backgroundColor: '#6f42c1',
                    borderColor: '#6f42c1',
                    color: '#fff',
                    minWidth: '170px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    opacity: requestLegalSection138Loading ? 0.8 : 1,
                    boxShadow: '0 4px 10px rgba(111,66,193,0.35)',
                  }}
                >
                  {requestLegalSection138Loading ? (
                    <>
                      <span
                        style={{
                          width: '13px',
                          height: '13px',
                          border: '2px solid rgba(255,255,255,0.4)',
                          borderTop: '2px solid #fff',
                          borderRadius: '50%',
                          display: 'inline-block',
                          animation: 'spin138 0.7s linear infinite',
                        }}
                      />
                      Submitting...
                    </>
                  ) : (
                    'Submit & Request'
                  )}
                </button>
              </div>
              <style>{`@keyframes spin138 { to { transform: rotate(360deg); } }`}</style>
            </div>
          </div>
        </div>
      )}

      {showSection138DocsModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15,23,42,.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '700px', width: '100%' }}>
            <div
              className="modal-content"
              style={{
                borderRadius: '18px',
                overflow: 'hidden',
                border: 'none',
                boxShadow: '0 18px 45px rgba(0,0,0,.18)',
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: '18px 24px',
                  borderBottom: '1px solid #eef2f7',
                  background: 'linear-gradient(135deg,#f4eeff,#fff)',
                }}
              >
                <div>
                  <h4 style={{ margin: 0, fontWeight: 700, color: '#1f2937', fontSize: '22px' }}>
                    Section 138 — Legal Team Documents
                  </h4>
                  <small style={{ color: '#6b7280', fontSize: '12px' }}>
                    Agreement No : <strong>{section138DocsData?.agreement_no || ''}</strong>
                  </small>
                </div>

                <button
                  className="btn-close"
                  onClick={() => {
                    setShowSection138DocsModal(false);
                    setSection138DocsData(null);
                  }}
                />
              </div>

              <div className="modal-body" style={{ padding: '20px 24px', maxHeight: '65vh', overflowY: 'auto' }}>
                {section138DocsLoading ? (
                  <div className="text-center py-4">Loading...</div>
                ) : section138DocsData ? (
                  <>
                    {/* CHEQUES - multiple */}
                    {Array.isArray(section138DocsData.cheque_documents) &&
                      section138DocsData.cheque_documents.length > 0 && (
                        <div style={{ marginBottom: '16px' }}>
                          <label
                            style={{
                              fontWeight: 700,
                              color: '#111827',
                              fontSize: '13px',
                              marginBottom: '8px',
                              display: 'block',
                            }}
                          >
                            Cheque(s)
                          </label>
                          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                            {section138DocsData.cheque_documents.map((path, i) => (
                              <a
                                key={i}
                                href={`${config.API_BASE_URL}${path}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '6px',
                                  padding: '9px 14px',
                                  borderRadius: '8px',
                                  border: '1px solid #e9d5ff',
                                  background: '#faf5ff',
                                  color: '#6f42c1',
                                  textDecoration: 'none',
                                  fontWeight: 600,
                                  fontSize: '12px',
                                }}
                              >
                                📄 Cheque {i + 1}
                              </a>
                            ))}
                          </div>
                        </div>
                      )}

                    {/* Other single docs */}
                    <div style={{ borderTop: '1px solid #eef2f7', paddingTop: '16px' }}>
                      <label
                        style={{
                          fontWeight: 700,
                          color: '#111827',
                          fontSize: '13px',
                          marginBottom: '10px',
                          display: 'block',
                        }}
                      >
                        Other Documents
                      </label>

                      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {[
                          { key: 'loan_agreement', label: 'Loan Agreement' },
                          { key: 'customer_details', label: 'Customer Details' },
                          { key: 'foreclosure', label: 'Foreclosure' },
                          { key: 'soa', label: 'SOA' },
                        ].map((doc) =>
                          section138DocsData[doc.key] ? (
                            <a
                              key={doc.key}
                              href={`${config.API_BASE_URL}${section138DocsData[doc.key]}`}
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '9px 14px',
                                borderRadius: '8px',
                                border: '1px solid #dbeafe',
                                background: '#eff6ff',
                                color: '#2563eb',
                                textDecoration: 'none',
                                fontWeight: 600,
                                fontSize: '12px',
                              }}
                            >
                              📄 {doc.label}
                            </a>
                          ) : null
                        )}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="text-center text-muted py-4">No Data Found</div>
                )}
              </div>

              <div
                className="modal-footer"
                style={{ padding: '14px 24px', borderTop: '1px solid #eef2f7', background: '#fafbfc' }}
              >
                <button
                  className="btn btn-secondary"
                  style={{ minWidth: '110px', height: '38px', borderRadius: '8px', fontWeight: 600 }}
                  onClick={() => {
                    setShowSection138DocsModal(false);
                    setSection138DocsData(null);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSection138NextStepModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ width: '100%', maxWidth: '600px', margin: 0 }}>
            <div
              className="modal-content"
              style={{
                borderRadius: '18px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 15px 45px rgba(0,0,0,0.22)',
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: '20px 26px',
                  borderBottom: '1px solid #ececec',
                  background: 'linear-gradient(135deg,#f4eeff,#fff)',
                }}
              >
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700, color: '#212529', fontSize: '20px' }}>
                    Section 138 — Legal Team Next Step
                  </h5>
                  <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '4px' }}>
                    Agreement No : <strong style={{ color: '#111827' }}>{section138NextStepAgreement}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  disabled={section138NextStepLoading}
                  onClick={() => {
                    setShowSection138NextStepModal(false);
                    setSection138NextStepAgreement('');
                    setSection138NextStepNote('');
                  }}
                />
              </div>

              <div className="modal-body" style={{ padding: '24px 26px' }}>
                <label
                  className="form-label"
                  style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                >
                  Note
                </label>

                <textarea
                  className="form-control"
                  rows="5"
                  placeholder="Enter note for next legal action..."
                  value={section138NextStepNote}
                  disabled={section138NextStepLoading}
                  onChange={(e) => setSection138NextStepNote(e.target.value)}
                  style={{
                    borderRadius: '10px',
                    padding: '12px 14px',
                    fontSize: '13.5px',
                    border: '1px solid #e0e0e0',
                    background: '#fafbfc',
                    resize: 'none',
                  }}
                />
              </div>

              <div
                className="modal-footer"
                style={{ padding: '16px 26px', borderTop: '1px solid #eef0f2', background: '#fafbfc' }}
              >
                <button
                  className="btn btn-light"
                  disabled={section138NextStepLoading}
                  onClick={() => {
                    setShowSection138NextStepModal(false);
                    setSection138NextStepAgreement('');
                    setSection138NextStepNote('');
                  }}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 600,
                    border: '1px solid #dcdcdc',
                  }}
                >
                  Cancel
                </button>

                <button
                  className="btn"
                  onClick={handleSubmitSection138NextStep}
                  disabled={section138NextStepLoading}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 700,
                    backgroundColor: '#6f42c1',
                    borderColor: '#6f42c1',
                    color: '#fff',
                    minWidth: '120px',
                  }}
                >
                  {section138NextStepLoading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showLegalLetterModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ width: '100%', maxWidth: '600px', margin: 0 }}>
            <div
              className="modal-content"
              style={{
                borderRadius: '18px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 15px 45px rgba(0,0,0,0.22)',
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: '20px 26px',
                  borderBottom: '1px solid #ececec',
                  background: 'linear-gradient(135deg,#e6f9fc,#fff)',
                }}
              >
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700, color: '#212529', fontSize: '20px' }}>Legal Letter</h5>
                  <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '4px' }}>
                    Agreement No : <strong style={{ color: '#111827' }}>{legalLetterAgreement}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  disabled={legalLetterLoading}
                  onClick={() => {
                    setShowLegalLetterModal(false);
                    setLegalLetterAgreement('');
                    setLegalLetterNote('');
                  }}
                />
              </div>

              <div className="modal-body" style={{ padding: '24px 26px' }}>
                <label
                  className="form-label"
                  style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                >
                  Note
                </label>
                <textarea
                  className="form-control"
                  rows="5"
                  placeholder="Enter note for Legal Letter..."
                  value={legalLetterNote}
                  disabled={legalLetterLoading}
                  onChange={(e) => setLegalLetterNote(e.target.value)}
                  style={{
                    borderRadius: '10px',
                    padding: '12px 14px',
                    fontSize: '13.5px',
                    border: '1px solid #e0e0e0',
                    background: '#fafbfc',
                    resize: 'none',
                  }}
                />
              </div>

              <div
                className="modal-footer"
                style={{ padding: '16px 26px', borderTop: '1px solid #eef0f2', background: '#fafbfc' }}
              >
                <button
                  className="btn btn-light"
                  disabled={legalLetterLoading}
                  onClick={() => {
                    setShowLegalLetterModal(false);
                    setLegalLetterAgreement('');
                    setLegalLetterNote('');
                  }}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 600,
                    border: '1px solid #dcdcdc',
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn"
                  onClick={handleSubmitLegalLetter}
                  disabled={legalLetterLoading}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 700,
                    backgroundColor: '#0dcaf0',
                    borderColor: '#0dcaf0',
                    color: '#fff',
                    minWidth: '120px',
                  }}
                >
                  {legalLetterLoading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showLegalLetterUploadModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ width: '100%', maxWidth: '760px', margin: 0 }}>
            <div
              className="modal-content"
              style={{
                borderRadius: '20px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
                width: '100%',
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: '22px 30px',
                  borderBottom: '1px solid #eef0f2',
                  background: 'linear-gradient(135deg,#fff4e8,#fff)',
                }}
              >
                <div>
                  <h5 style={{ margin: 0, fontWeight: 800, color: '#1f2937', fontSize: '20px' }}>
                    Upload Review Details — Legal Letter
                  </h5>
                  <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '5px' }}>
                    Agreement No : <strong style={{ color: '#111827' }}>{legalLetterUploadAgreement}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  disabled={legalLetterUploadLoading}
                  onClick={() => {
                    setShowLegalLetterUploadModal(false);
                    setLegalLetterUploadAgreement('');
                    setLegalLetterFiles({
                      cheques: [],
                      loan_agreement: null,
                      customer_details: null,
                      foreclosure: null,
                      soa: null,
                      other_documents: [],
                    });
                  }}
                />
              </div>

              <div className="modal-body" style={{ padding: '28px 30px', maxHeight: '68vh', overflowY: 'auto' }}>
                <p style={{ fontSize: '13.5px', color: '#6b7280', marginBottom: '22px' }}>
                  Upload the review documents for this Legal Letter case.
                </p>

                {/* CHEQUES - multiple */}
                <div style={{ marginBottom: '18px' }}>
                  <label
                    className="form-label"
                    style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                  >
                    Cheque(s)
                  </label>
                  <label
                    htmlFor="legalLetterChequeInput"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      border: '1.5px dashed #d1d5db',
                      borderRadius: '12px',
                      padding: '14px 18px',
                      background: '#fafbfc',
                      cursor: legalLetterUploadLoading ? 'not-allowed' : 'pointer',
                      color: '#6b7280',
                      fontSize: '13px',
                      fontWeight: 600,
                    }}
                  >
                    📎 Click to upload Cheque(s)
                  </label>
                  <input
                    id="legalLetterChequeInput"
                    type="file"
                    multiple
                    hidden
                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                    disabled={legalLetterUploadLoading}
                    onChange={(e) => setLegalLetterFiles((prev) => ({ ...prev, cheques: Array.from(e.target.files) }))}
                  />
                  {legalLetterFiles.cheques.length > 0 && (
                    <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {legalLetterFiles.cheques.map((f, i) => (
                        <div
                          key={i}
                          style={{
                            fontSize: '12px',
                            color: '#374151',
                            background: '#f3f4f6',
                            border: '1px solid #e5e7eb',
                            borderRadius: '20px',
                            padding: '6px 12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            maxWidth: '220px',
                          }}
                        >
                          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            📄 {f.name}
                          </span>
                          <button
                            type="button"
                            disabled={legalLetterUploadLoading}
                            onClick={() =>
                              setLegalLetterFiles((prev) => ({
                                ...prev,
                                cheques: prev.cheques.filter((_, idx) => idx !== i),
                              }))
                            }
                            style={{
                              border: 'none',
                              background: 'transparent',
                              color: '#dc3545',
                              fontSize: '14px',
                              cursor: 'pointer',
                              lineHeight: 1,
                              fontWeight: 700,
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* SINGLE FILE UPLOADS */}
                {[
                  { key: 'loan_agreement', label: 'Loan Agreement' },
                  { key: 'customer_details', label: 'Customer Details' },
                  { key: 'foreclosure', label: 'Foreclosure' },
                  { key: 'soa', label: 'Statement of Account (SOA)' },
                ].map((doc) => (
                  <div key={doc.key} style={{ marginBottom: '18px' }}>
                    <label
                      className="form-label"
                      style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                    >
                      {doc.label}
                    </label>
                    <label
                      htmlFor={`legal-letter-${doc.key}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '8px',
                        border: '1.5px dashed #d1d5db',
                        borderRadius: '12px',
                        padding: '14px 18px',
                        background: '#fafbfc',
                        cursor: legalLetterUploadLoading ? 'not-allowed' : 'pointer',
                        color: '#6b7280',
                        fontSize: '13px',
                        fontWeight: 600,
                      }}
                    >
                      <span>
                        📎 {legalLetterFiles[doc.key] ? legalLetterFiles[doc.key].name : `Click to upload ${doc.label}`}
                      </span>
                      {legalLetterFiles[doc.key] && (
                        <span style={{ color: '#16a34a', fontSize: '12px', fontWeight: 700 }}>✓ Uploaded</span>
                      )}
                    </label>
                    <input
                      id={`legal-letter-${doc.key}`}
                      type="file"
                      hidden
                      accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                      disabled={legalLetterUploadLoading}
                      onChange={(e) => setLegalLetterFiles((prev) => ({ ...prev, [doc.key]: e.target.files[0] }))}
                    />
                  </div>
                ))}

                {/* OTHER DOCUMENTS - multiple, optional */}
                <div style={{ marginBottom: '18px' }}>
                  <label
                    className="form-label"
                    style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                  >
                    Other Documents (optional)
                  </label>
                  <label
                    htmlFor="legalLetterOtherDocsInput"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      border: '1.5px dashed #d1d5db',
                      borderRadius: '12px',
                      padding: '14px 18px',
                      background: '#fafbfc',
                      cursor: legalLetterUploadLoading ? 'not-allowed' : 'pointer',
                      color: '#6b7280',
                      fontSize: '13px',
                      fontWeight: 600,
                    }}
                  >
                    📎 Click to upload Other Documents
                  </label>
                  <input
                    id="legalLetterOtherDocsInput"
                    type="file"
                    multiple
                    hidden
                    accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
                    disabled={legalLetterUploadLoading}
                    onChange={(e) =>
                      setLegalLetterFiles((prev) => ({ ...prev, other_documents: Array.from(e.target.files) }))
                    }
                  />
                  {legalLetterFiles.other_documents.length > 0 && (
                    <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                      {legalLetterFiles.other_documents.map((f, i) => (
                        <div
                          key={i}
                          style={{
                            fontSize: '12px',
                            color: '#374151',
                            background: '#f3f4f6',
                            border: '1px solid #e5e7eb',
                            borderRadius: '20px',
                            padding: '6px 12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            maxWidth: '220px',
                          }}
                        >
                          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            📄 {f.name}
                          </span>
                          <button
                            type="button"
                            disabled={legalLetterUploadLoading}
                            onClick={() =>
                              setLegalLetterFiles((prev) => ({
                                ...prev,
                                other_documents: prev.other_documents.filter((_, idx) => idx !== i),
                              }))
                            }
                            style={{
                              border: 'none',
                              background: 'transparent',
                              color: '#dc3545',
                              fontSize: '14px',
                              cursor: 'pointer',
                              lineHeight: 1,
                              fontWeight: 700,
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div
                className="modal-footer"
                style={{ padding: '16px 30px', borderTop: '1px solid #eef0f2', background: '#fafbfc' }}
              >
                <button
                  className="btn btn-light"
                  disabled={legalLetterUploadLoading}
                  onClick={() => {
                    setShowLegalLetterUploadModal(false);
                    setLegalLetterUploadAgreement('');
                    setLegalLetterFiles({
                      cheques: [],
                      loan_agreement: null,
                      customer_details: null,
                      foreclosure: null,
                      soa: null,
                      other_documents: [],
                    });
                  }}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 600,
                    border: '1px solid #dcdcdc',
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn"
                  onClick={handleSubmitLegalLetterUpload}
                  disabled={legalLetterUploadLoading}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 700,
                    backgroundColor: '#fd7e14',
                    borderColor: '#fd7e14',
                    color: '#fff',
                    minWidth: '170px',
                  }}
                >
                  {legalLetterUploadLoading ? 'Submitting...' : 'Submit & Forward'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showLegalLetterDocsModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(15,23,42,.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '700px', width: '100%' }}>
            <div
              className="modal-content"
              style={{
                borderRadius: '18px',
                overflow: 'hidden',
                border: 'none',
                boxShadow: '0 18px 45px rgba(0,0,0,.18)',
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: '18px 24px',
                  borderBottom: '1px solid #eef2f7',
                  background: 'linear-gradient(135deg,#fff4e8,#fff)',
                }}
              >
                <div>
                  <h4 style={{ margin: 0, fontWeight: 700, color: '#1f2937', fontSize: '22px' }}>
                    Legal Letter — Documents
                  </h4>
                  <small style={{ color: '#6b7280', fontSize: '12px' }}>
                    Agreement No : <strong>{legalLetterDocsData?.agreement_no || ''}</strong>
                  </small>
                </div>
                <button
                  className="btn-close"
                  onClick={() => {
                    setShowLegalLetterDocsModal(false);
                    setLegalLetterDocsData(null);
                  }}
                />
              </div>

              <div className="modal-body" style={{ padding: '20px 24px', maxHeight: '65vh', overflowY: 'auto' }}>
                {legalLetterDocsLoading ? (
                  <div className="text-center py-4">Loading...</div>
                ) : legalLetterDocsData ? (
                  <>
                    {Array.isArray(legalLetterDocsData.cheque_documents) &&
                      legalLetterDocsData.cheque_documents.length > 0 && (
                        <div style={{ marginBottom: '16px' }}>
                          <label
                            style={{
                              fontWeight: 700,
                              color: '#111827',
                              fontSize: '13px',
                              marginBottom: '8px',
                              display: 'block',
                            }}
                          >
                            Cheque(s)
                          </label>
                          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                            {legalLetterDocsData.cheque_documents.map((path, i) => (
                              <a
                                key={i}
                                href={`${config.API_BASE_URL}${path}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '6px',
                                  padding: '9px 14px',
                                  borderRadius: '8px',
                                  border: '1px solid #ffe0b3',
                                  background: '#fff8ec',
                                  color: '#fd7e14',
                                  textDecoration: 'none',
                                  fontWeight: 600,
                                  fontSize: '12px',
                                }}
                              >
                                📄 Cheque {i + 1}
                              </a>
                            ))}
                          </div>
                        </div>
                      )}

                    <div style={{ borderTop: '1px solid #eef2f7', paddingTop: '16px' }}>
                      <label
                        style={{
                          fontWeight: 700,
                          color: '#111827',
                          fontSize: '13px',
                          marginBottom: '10px',
                          display: 'block',
                        }}
                      >
                        Other Documents
                      </label>
                      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        {[
                          { key: 'loan_agreement', label: 'Loan Agreement' },
                          { key: 'customer_details', label: 'Customer Details' },
                          { key: 'foreclosure', label: 'Foreclosure' },
                          { key: 'soa', label: 'SOA' },
                        ].map((doc) =>
                          legalLetterDocsData[doc.key] ? (
                            <a
                              key={doc.key}
                              href={`${config.API_BASE_URL}${legalLetterDocsData[doc.key]}`}
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '9px 14px',
                                borderRadius: '8px',
                                border: '1px solid #dbeafe',
                                background: '#eff6ff',
                                color: '#2563eb',
                                textDecoration: 'none',
                                fontWeight: 600,
                                fontSize: '12px',
                              }}
                            >
                              📄 {doc.label}
                            </a>
                          ) : null
                        )}
                        {Array.isArray(legalLetterDocsData.other_documents) &&
                          legalLetterDocsData.other_documents.map((path, i) => (
                            <a
                              key={i}
                              href={`${config.API_BASE_URL}${path}`}
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '9px 14px',
                                borderRadius: '8px',
                                border: '1px solid #dbeafe',
                                background: '#eff6ff',
                                color: '#2563eb',
                                textDecoration: 'none',
                                fontWeight: 600,
                                fontSize: '12px',
                              }}
                            >
                              📄 Other {i + 1}
                            </a>
                          ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="text-center text-muted py-4">No Data Found</div>
                )}
              </div>

              <div
                className="modal-footer"
                style={{ padding: '14px 24px', borderTop: '1px solid #eef2f7', background: '#fafbfc' }}
              >
                <button
                  className="btn btn-secondary"
                  style={{ minWidth: '110px', height: '38px', borderRadius: '8px', fontWeight: 600 }}
                  onClick={() => {
                    setShowLegalLetterDocsModal(false);
                    setLegalLetterDocsData(null);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showLegalLetterNextStepModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ width: '100%', maxWidth: '600px', margin: 0 }}>
            <div
              className="modal-content"
              style={{
                borderRadius: '18px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 15px 45px rgba(0,0,0,0.22)',
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: '20px 26px',
                  borderBottom: '1px solid #ececec',
                  background: 'linear-gradient(135deg,#e6f9f0,#fff)',
                }}
              >
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700, color: '#212529', fontSize: '20px' }}>
                    Legal Letter — Next Step
                  </h5>
                  <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '4px' }}>
                    Agreement No : <strong style={{ color: '#111827' }}>{legalLetterNextStepAgreement}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  disabled={legalLetterNextStepLoading}
                  onClick={() => {
                    setShowLegalLetterNextStepModal(false);
                    setLegalLetterNextStepAgreement('');
                    setLegalLetterNextStepNote('');
                  }}
                />
              </div>

              <div className="modal-body" style={{ padding: '24px 26px' }}>
                <label
                  className="form-label"
                  style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                >
                  Note
                </label>
                <textarea
                  className="form-control"
                  rows="5"
                  placeholder="Enter note for next step..."
                  value={legalLetterNextStepNote}
                  disabled={legalLetterNextStepLoading}
                  onChange={(e) => setLegalLetterNextStepNote(e.target.value)}
                  style={{
                    borderRadius: '10px',
                    padding: '12px 14px',
                    fontSize: '13.5px',
                    border: '1px solid #e0e0e0',
                    background: '#fafbfc',
                    resize: 'none',
                  }}
                />
              </div>

              <div
                className="modal-footer"
                style={{ padding: '16px 26px', borderTop: '1px solid #eef0f2', background: '#fafbfc' }}
              >
                <button
                  className="btn btn-light"
                  disabled={legalLetterNextStepLoading}
                  onClick={() => {
                    setShowLegalLetterNextStepModal(false);
                    setLegalLetterNextStepAgreement('');
                    setLegalLetterNextStepNote('');
                  }}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 600,
                    border: '1px solid #dcdcdc',
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn"
                  onClick={handleSubmitLegalLetterNextStep}
                  disabled={legalLetterNextStepLoading}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 700,
                    backgroundColor: '#198754',
                    borderColor: '#198754',
                    color: '#fff',
                    minWidth: '120px',
                  }}
                >
                  {legalLetterNextStepLoading ? 'Submitting...' : 'Submit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showSurrenderActionModal && (
        <div
          className="modal show fade d-flex align-items-center justify-content-center"
          tabIndex="-1"
          style={{
            position: 'fixed',
            inset: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(15, 23, 42, 0.55)',
            backdropFilter: 'blur(3px)',
            zIndex: 999999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ width: '100%', maxWidth: '560px', margin: 0 }}>
            <div
              className="modal-content"
              style={{
                borderRadius: '18px',
                border: 'none',
                overflow: 'hidden',
                boxShadow: '0 15px 45px rgba(0,0,0,0.22)',
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: '20px 26px',
                  borderBottom: '1px solid #ececec',
                  background:
                    surrenderAction === 'approve'
                      ? 'linear-gradient(135deg,#e9f9ef,#fff)'
                      : 'linear-gradient(135deg,#fdeaea,#fff)',
                }}
              >
                <div>
                  <h5 style={{ margin: 0, fontWeight: 700, color: '#212529', fontSize: '20px' }}>
                    {surrenderAction === 'approve' ? 'Accept Surrender Request' : 'Reject Surrender Request'}
                  </h5>
                  <div style={{ fontSize: '13px', color: '#6c757d', marginTop: '4px' }}>
                    Agreement No : <strong style={{ color: '#111827' }}>{surrenderActionAgreement}</strong>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  disabled={surrenderActionLoading}
                  onClick={() => {
                    setShowSurrenderActionModal(false);
                    setSurrenderActionAgreement('');
                    setSurrenderAction('');
                    setSurrenderActionNote('');
                  }}
                />
              </div>

              <div className="modal-body" style={{ padding: '24px 26px' }}>
                <label
                  className="form-label"
                  style={{ fontWeight: 600, fontSize: '13px', color: '#374151', marginBottom: '8px' }}
                >
                  Note
                </label>
                <textarea
                  className="form-control"
                  rows="5"
                  placeholder={
                    surrenderAction === 'approve'
                      ? 'Enter note for approving surrender...'
                      : 'Enter reason for rejecting surrender...'
                  }
                  value={surrenderActionNote}
                  disabled={surrenderActionLoading}
                  onChange={(e) => setSurrenderActionNote(e.target.value)}
                  style={{
                    borderRadius: '10px',
                    padding: '12px 14px',
                    fontSize: '13.5px',
                    border: '1px solid #e0e0e0',
                    background: '#fafbfc',
                    resize: 'none',
                  }}
                />
              </div>

              <div
                className="modal-footer"
                style={{ padding: '16px 26px', borderTop: '1px solid #eef0f2', background: '#fafbfc' }}
              >
                <button
                  className="btn btn-light"
                  disabled={surrenderActionLoading}
                  onClick={() => {
                    setShowSurrenderActionModal(false);
                    setSurrenderActionAgreement('');
                    setSurrenderAction('');
                    setSurrenderActionNote('');
                  }}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 600,
                    border: '1px solid #dcdcdc',
                  }}
                >
                  Cancel
                </button>

                <button
                  className="btn"
                  onClick={submitSurrenderAction}
                  disabled={surrenderActionLoading}
                  style={{
                    padding: '8px 18px',
                    fontSize: '12.5px',
                    height: '38px',
                    borderRadius: '9px',
                    fontWeight: 700,
                    backgroundColor: surrenderAction === 'approve' ? '#198754' : '#dc3545',
                    borderColor: surrenderAction === 'approve' ? '#198754' : '#dc3545',
                    color: '#fff',
                    minWidth: '120px',
                  }}
                >
                  {surrenderActionLoading ? 'Submitting...' : surrenderAction === 'approve' ? 'Accept' : 'Reject'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
}

export default VehicleRepoList;
